export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ROLE_NAME_REGEX = /^[A-Za-z0-9 ,]+$/;
export const TEAM_NAME_REGEX = /^[A-Za-z0-9 ,]+$/;
export const ROLE_DISC_REGEX = /^[\nA-Za-z0-9 .,_-]+$/;
export const ROLE_SPEC_REGEX = /^[\nA-Za-z0-9 ?'().,_-]+$/;
export const STEPS_DISC_REGEX = /^[A-Za-z0-9 \n.,_(-]+$/;
export const WHITE_SPACE_REGEX = /^\s*\S.*$/;
export const NO_NUMBER_REGEX = /^[^\d]+$/;
export const MAX_SELECT_LABEL_LEGTH = 3;
export const FIRST_LAST_NAME_REGEX = /^[A-Za-z ]+$/;
export const STEP_DAYS_REGEX = /^[0-9]+$/;
export const DOC_CHECKLIST_ITEM_NAME_REGEX = /^[A-Za-z0-9 ,_-]+$/;
export const NUMBER_WITH_7_9_DIGITS_REGEX = /^\d{7,9}$/;
export const DOCUMENT_NAME_REGEX = /^[A-Za-z0-9\-_& ]*$/;
export const NUMBER_WITH_0_9_DIGITS_REGEX = /^[0-9+()-\s]+$/;
export const NUMBER_WITH_0_9_DIGITS_REGEX_NO_SPECIAL_CHAR = /^[0-9\s]+$/;
export const UNDERSCORE_NOT_ALLOWED_REGEX = /^[^_]*$/;
export const LEADING_TRAILING_SPACES_NOT_ALLOWED_REGEX = /^(?!\s)(.*\S$|$)/;

export const IS_MULTI_SELECT_FILTER = true;

export const IO_IOS_SEARCH_SIZE = 21;

export const USER_MAX_LENGTH = 25;

export const USER_ACCESS_MIN = 1;

export const LIST_CRR_PAGE = 1;

export const REACT_TABLE_ORDER = "DSC";

export const DEF_SORT_ORDER = "DESC";

export const ROLE_DEF_COLUMN = "created_at";

export const STEPS_DEF_COLUMN = "created_at";

export const USER_DEF_COLUMN = "created_at";

export const USER_LIST_ROWS_DEF = 10;

export const LIST_ROWS_100 = 100;

export const ROLE_LIST_ROWS_DEF = 10;

export const TEAMS_LIST_ROWS_DEF = 10;

export const TEAMS_DEFAULT_SORT_COLUMN = "created_at";

export const STEPS_LIST_ROWS_DEF = 10;

export const STEPS_DEFAULT_SORT_COLUMN = "created_at";

export const STAGES_LIST_ROWS_DEF = 10;

export const STAGES_DEFAULT_SORT_COLUMN = "created_at";

export const CUSTOM_PAGINATOR_VALUES = [10, 20, 30];

export const PAGINATOR_ROWS_DEF = 10;

export const PAGINATOR_FIRST = 0;

export const DEF_INC_COUNT = 1;

export const EDIT = "edit";

export const VIEW = "view";

export const ADD = "add";

export const VIEWALL = "view-all";

export const MAPPING = "mapping";

export const FORMS = "forms";

export const QUESTIONNAIRES = "questionnaires";

export const POP_UP_CLOSE_1000 = 2000;

export const POP_UP_CLOSE_2000 = 2000;

export const POP_UP_CLOSE_10000 = 10000;

export const VALID_ORGANIZATION_EMAIL = "The email id must be a valid organization email";

export const DELETE_HEADER_TITLE = "Delete Role";

export const DELETE_ROLE_CONTENT = "Are you sure, you want to delete this role?";
export const DELETE_DESIGNATION_MANAGER_TITLE = "Delete Designation";

export const DELETE_DESIGNATION_MANAGER_CONTENT =
  "Are you sure you want to delete this designation, after deleting this designation it’ll not going to populate in the dropdowns on user selection.";

export const DELETE_STAGE_TITLE = "Delete Stage";

export const DELETE_STAGE_CONTENT =
  "Are you sure, you want to delete the Stage?";

export const DELETE_HEADER_TITLE_STEP = "Delete Step";

export const DELETE_STEP_CONTENT = "Are you sure, you want to delete the Step?";

export const HIDE_TABLE_PAGINATOR = true;

export const REORDERABLE_ROWS = true;

export const IS_SELECT_FILTER = true;

export const DELETE_DOC_CHECKLIST_ITEM_TITLE = "Delete Document Checklist Item";

export const DELETE_DOC_CHECKLIST_ITEM_CONTENT =
  "Are you sure, you want to delete the Document Checklist Item?";

export const DELETE_DOC_TYPE_ITEM_TITLE = "Delete Document Type";

export const DELETE_DOC_TYPE_ITEM_CONTENT =
  "Are you sure, you want to delete the Document Type?";

export const DELETE_RECEIPT_TITLE = "Delete Receipt";

export const DELETE_CHILD_RECEIPT_TITLE = "Delete Receipt";

export const DELETE_RECEIPT_CONTENT =
  "Are you sure, you want to delete All the attached receipts? To remove a single receipt, please click on the eye icon.";

export const DELETE_CHILD_RECEIPT_CONTENT =
  "Are you sure, you want to delete receipt?";

export const DELETE_BENEFICIARY_TITLE = "Delete Beneficiary";

export const DELETE_BENEFICIARY_CONTENT =
  "Are you sure, you want to delete the Beneficiary?";

export const DELETE_DERIVATIVE_TITLE = "Delete Derivative/Co-applicant";

export const DELETE_DERIVATIVE_CONTENT =
  "Are you sure, you want to remove this derivative/co-applicant from this case?";

export const DELETE_PETITIONER_TITLE = "Delete Petitioner/Sponsor";

export const DELETE_PETITIONER_CONTENT =
  "Are you sure, you want to remove this petitioner/sponsor?";

export const MAX_TEN_FILES_ALLOWED = "Maximum ten files are allowed at a time.";
export const MAX_FIFTY_FILES_ALLOWED_COUNT = 50;
export const MAX_FIFTY_FILES_ALLOWED = "Maximum fifty files are allowed at a time.";

export const DOCUMENTS_MAX_FILES_SIZE_ALLOWED = 250;

export const DOCUMENTS_MAX_ALLOWED_FILES_SIZE_250MB_ALLOWED =
`It seems that one of your file exceed maximum size of ${DOCUMENTS_MAX_FILES_SIZE_ALLOWED} MB.`;


export const MAX_ONE_FILE_ALLOWED = "Maximum one file is allowed.";

export const MAX_ALLOWED_FILES_SIZE_ALLOWED =
  "It seems that one of your file exceed maximum size of 20 MB.";

export const MAX_ALLOWED_FILES_SIZE_35MB_ALLOWED =
`It seems that one of your file exceed maximum size of ${process.env.REACT_APP_REPLY_REPLY_ALL_FILE_SIZE} MB.`;

export const DELETE_DOC_CHECKLIST_TITLE = "Delete Document Checklist";

export const DELETE_DOC_CHECKLIST_CONTENT =
  "Are you sure, you want to delete the Document Checklist?";
export const DELETE_QUESTIONS_TITLE = "Delete Question";

export const DELETE_QUESTIONS_CONTENT =
  "Are you sure you want to delete the Question?";

export const DATE_RANGE_VALUE =
  "Please select start date and end date in the date range value.";
export const DATE_RANGE_VALUE_TWO =
  "Please select end date in the date range value.";

export const DELETE_FORM_MANAGER_TITLE = "Delete Form";

export const DELETE_FORM_MANAGER_CONTENT =
  "Are you sure, you want to delete the form?";
export const DELETE_NOTE_TITLE = "Delete Note";

export const DELETE_NOTE_CONTENT = "Are you sure, you want to delete the Note permanently?";

export const DELETE_DOCUMENT_TITLE = "Delete Document";
export const DELETE_DOCUMENT_CONTENT =
  "Are you sure, you want to delete the Document?";

export const DELETE_FORM_TITLE = "Delete Form";
export const DELETE_FORM_CONTENT =
  "Are you sure, you want to delete the Form?";


export const DELETE_EMAIL_TEMPLATE_TITLE = "Delete Email Template"
export const DELETE_EMAIL_TEMPLATE_CONTENT =
  "Are you sure you want to delete this Email Template?"


export const DELETE_DRAFTS_TITLE = "Delete Draft";
export const DELETE_DRAFTS_CONTENT =
  "Are you sure, you want to delete the draft permanently?";

export const DELETE_ALERT_TITLE = "Delete Alert";
export const DELETE_ALERT_CONTENT =
  "Are you sure, you want to permanently delete the alert?";

export const DELETE_QUESTIONNAIRE_TITLE = "Delete Questionnaire";
export const DELETE_QUESTIONNAIRE_CONTENT =
  "Are you sure, you want to delete the Questionnaire?";

export const DELETE_REMINDER_TITLE = "Delete Reminder";
export const DELETE_REMINDER_CONTENT =
  "Are you sure, you want to delete the Reminder?";

export const DELETE_EVENT_TITLE = "Delete Event";
export const DELETE_EVENT_CONTENT =
  "Are you sure, you want to delete the Event?";

export const DELETE_NOTIFICATION_TITLE = "Delete Notification";
export const DELETE_NOTIFICATION_CONTENT =
  "Are you sure, you want to delete the notification from the DB permanently?";

export const DELETE_REPORT_TITLE = "Delete Report";
export const DELETE_REPORT_CONTENT =
  "Are you sure, you want to delete the Report?";

export const DELETE_RELATIVES_TITLE = "Delete Relatives";
export const DELETE_RELATIVES_CONTENT =
  "Are you sure, you want to delete the Relative?";

export const DELETE_ATTACHMENT_TITLE = "Delete Attachment";
export const DELETE_ATTACHMENT_CONTENT =
  "Are you sure, you want to delete the Attachment?";

export const DEactive_ALERT_TITLE = "Deactivate Alert";
export const DEactive_ALERT_CONTENT =
  "Are you sure, you want to deactivate the alert?";
export const REactive_ALERT_TITLE = "Reactivate Alert";
export const REactive_ALERT_CONTENT =
  "Are you sure, you want to reactivate the alert?";

export const DELETE_FILLING_TITLE = "Delete Filing";
export const DELETE_FILLING_CONTENT =
  "Are you sure, you want to delete this filing?";

export const SEND_DOC_CHK_LIST = "Send Document Checklist";
export const SEND_DOC_CHK_LIST_CONTENT =
  "Are you sure, you want to send the document checklist?";

export const ADD_DOC_CHK_LIST = "Add Related Documents";
export const ADD_DOC_CHK_LIST_CONTENT =
  "Are you sure, you want to add the related documents?";

// GRAPH API
export const IMAGE_NOT_UPLOADED =
  "Profile image not uploaded, Sharepoint issue";
export const ALLOWEDIMAGETYPES =
  "Allowed image file extensions are .jpg, .jpeg and .png.";
export const IMAGESIZE = "Image size must not exceed 2.5 MB.";
export const IMAGESIZEINKB = 2500;
export const ALLOWEDFILETYPES = "Allowed file types are";
export const ALLOWEDFILETYPEPDF = "Only PDF files are allowed for forms.";
export const FILE_NOT_UPLOADED =
  "File not uploaded on sharepoint. Please try again.";
export const FileSIZEINKB = 50000;
export const FILESIZE = "File size must not exceed 50 MB.";
export const PRIMARYCONATCT = "Please select atleast one primary contact."
export const LOGIN_OTHER_BROWSER = "It seems you're logged into other browser tab or window.";
export const USER_NOT_EXIST = "Issue in login please ask your admin to check your account is created or not.";
// User Management Add User Designation Options
export const FILL_FORM_TITLE = "Fill Form with Questionnaire";
export const FILL_FORM__QUESTIONNAIRE_CONTENT =
  "Are you sure, you want to fill form with the associated Questionnaire?";
export const DESIGNATIONS_OPTIONS = [
  { label: "Senior Attorney", value: "Senior Attorney" },
  { label: "Attorneys", value: "Attorneys" },
  { label: "Team Leads", value: "Team Leads" },
  {
    label: "Business Immigration Analyst",
    value: "Business Immigration Analyst",
  },
  { label: "Immigrant Visa Specialists", value: "Immigrant Visa Specialists" },
  { label: "RFE Case Manager", value: "RFE Case Manager" },
  { label: "RFE Attorney", value: "RFE Attorney" },
];

// User Management Add User Department Options
export const DEPARTMENT_OPTIONS = [
  { label: "Human Resources", value: "Human Resources" },
  { label: "Billing", value: "Billing" },
  { label: "Onboarding", value: "Onboarding" },
  { label: "Offboarding", value: "Offboarding" },
  { label: "Administrative", value: "Administrative" },
  { label: "Legal", value: "Legal" },
  { label: "Management", value: "Management" },
  { label: "Business and IT", value: "Business and IT" },
  { label: "Client Liason", value: "Client Liason" }
];

export const ALL = "all";

export const SUCCESS_STATUS = 200;
export const SUCCESS_STATUS_ERROR = 201;

// Role Options
export const roleOptions = [
  { label: "Role 1", value: "Role 1" },
  { label: "Role 2", value: "Role 2" },
  { label: "Role 3", value: "Role 3" },
  { label: "Role 4", value: "Role 4" },
];

// Member Name Options
export const memberNameOptions = [
  { label: "Member Name 1", value: "Member Name 1" },
  { label: "Member Name 2", value: "Member Name 2" },
  { label: "Member Name 3", value: "Member Name 3" },
  { label: "Member Name 4", value: "Member Name 4" },
];

export const sharePointImgUrl =
  "https://matellio068.sharepoint.com/Shared%20Documents/formDataName/Screenshot%20from%202023-09-22%2018-36-37.png";

export const ROLE = "role";

export const ATTORNEYS = "Attorneys";
export const BI_ANALYST = "Business Immigration Analyst";
export const TEAM_LEADS = "Team Leads";
export const SENIOR_ATTORNEY = "Senior Attorney";
export const IMM_VISA_SPECIALISTS = "Immigrant Visa Specialists";
export const RFE_CASE_MANAGER = "RFE Case Manager";
export const RFE_ATTORNEY = "RFE Attorney";

export const foldersNameKnowledgeBaseOptions = [
  { label: "Cover Pages For Filing", value: "Cover Pages For Filing" },
  { label: "Contract Templates", value: "Contract Templates" },
  { label: "Custom Fields", value: "Custom Fields" },
  { label: "Document Checklist", value: "Document Checklist" },
  { label: "Document Templates", value: "Document Templates" },
  { label: "Email Templates", value: "Email Templates" },
  { label: "Forms", value: "Forms" },
  { label: "Letter Templates", value: "Letter Templates" },
  { label: "Questionnaires", value: "Questionnaires" },
  { label: "Refer Keyword", value: "Refer Keyword" },
  { label: "Shipping Information", value: "Shipping Information" },
  { label: "Steps and Reminders", value: "Steps and Reminders" },
];

// Salutation Options
export const salutationOptions = [
  { label: "Dr.", value: "Dr." },
  { label: "Hon.", value: "Hon." },
  { label: "Lic.", value: "Lic." },
  { label: "Miss.", value: "Miss." },
  { label: "Mr.", value: "Mr." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Ms.", value: "Ms." },
  { label: "Sir.", value: "Sir." },
];

// Main Contact Options
export const mainContactOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

// Gender Options
export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

// Gender Options
export const allowedFileTypesOptions = [
  { label: "JPG", value: "JPG" },
  { label: "JPEG", value: "JPEG" },
  { label: "PNG", value: "PNG" },
  { label: "GIF", value: "GIF" },
  { label: "PDF", value: "PDF" },
  { label: "DOC", value: "DOC" },
  { label: "DOCX", value: "DOCX" },
  { label: "PPTX", value: "PPTX" },
  { label: "XLSX", value: "XLSX" },
  { label: "XLS", value: "XLS" },
  { label: "TXT", value: "TXT" },
];

export const DOB_FORMAT = "MM-DD-YYYY";
export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_FORMAT_EMAIL_REPLY = "MM/DD/YYYY HH:mm:ss"
export const DATE_FORMAT_TIME_ZONE = "MM-DD-YYYY HH:mm:ss.SSSZ"

export const CONTACT_INFO_SCREEN = "Contact Info";

export const COUNTRY_OPTIONS = [
  {
    "value": "Afghanistan",
    "label": "Afghanistan"
  },
  {
    "label": "Albania",
    "value": "Albania"
  },
  {
    "label": "Algeria",
    "value": "Algeria"
  },
  {
    "label": "Andorra",
    "value": "Andorra"
  },
  {
    "label": "Angola",
    "value": "Angola"
  },
  {
    "label": "Antigua and Barbuda",
    "value": "Antigua and Barbuda"
  },
  {
    "label": "Argentina",
    "value": "Argentina"
  },
  {
    "label": "Armenia",
    "value": "Armenia"
  },
  {
    "label": "Australia",
    "value": "Australia"
  },
  {
    "label": "Austria",
    "value": "Austria"
  },
  {
    "label": "Azerbaijan",
    "value": "Azerbaijan"
  },
  {
    "label": "Bahamas",
    "value": "Bahamas"
  },
  {
    "label": "Bahrain",
    "value": "Bahrain"
  },
  {
    "label": "Bangladesh",
    "value": "Bangladesh"
  },
  {
    "label": "Barbados",
    "value": "Barbados"
  },
  {
    "label": "Belarus",
    "value": "Belarus"
  },
  {
    "label": "Belgium",
    "value": "Belgium"
  },
  {
    "label": "Belize",
    "value": "Belize"
  },
  {
    "label": "Benin",
    "value": "Benin"
  },
  {
    "label": "Bhutan",
    "value": "Bhutan"
  },
  {
    "label": "Bolivia",
    "value": "Bolivia"
  },
  {
    "label": "Bosnia and Herzegov",
    "value": "Bosnia and Herzegov"
  },
  {
    "label": "Botswana",
    "value": "Botswana"
  },
  {
    "label": "Brazil",
    "value": "Brazil"
  },
  {
    "label": "Brunei Darussalam",
    "value": "Brunei Darussalam"
  },
  {
    "label": "Bulgaria",
    "value": "Bulgaria"
  },
  {
    "label": "Burkina Faso",
    "value": "Burkina Faso"
  },
  {
    "label": "Burundi",
    "value": "Burundi"
  },
  {
    "label": "Cambodia",
    "value": "Cambodia"
  },
  {
    "label": "Cameroon",
    "value": "Cameroon"
  },
  {
    "label": "Canada",
    "value": "Canada"
  },
  {
    "label": "Cape Verde",
    "value": "Cape Verde"
  },
  {
    "label": "Central African Republic",
    "value": "Central African Republic"
  },
  {
    "label": "Chad",
    "value": "Chad"
  },
  {
    "label": "Chile",
    "value": "Chile"
  },
  {
    "label": "China",
    "value": "China"
  },
  {
    "label": "Colombia",
    "value": "Colombia"
  },
  {
    "label": "Comoros",
    "value": "Comoros"
  },
  {
    "label": "Congo",
    "value": "Congo"
  },
  {
    "label": "Democratic Republic of Congo",
    "value": "Democratic Republic of Congo"
  },
  {
    "label": "Costa Rica",
    "value": "Costa Rica"
  },
  {
    "label": "Croatia",
    "value": "Croatia"
  },
  {
    "label": "Cuba",
    "value": "Cuba"
  },
  {
    "label": "Cyprus",
    "value": "Cyprus"
  },
  {
    "label": "Czech Republic",
    "value": "Czech Republic"
  },
  {
    "label": "Denmark",
    "value": "Denmark"
  },
  {
    "label": "Djibouti",
    "value": "Djibouti"
  },
  {
    "label": "Dominica",
    "value": "Dominica"
  },
  {
    "label": "Dominican Republic",
    "value": "Dominican Republic"
  },
  {
    "label": "Ecuador",
    "value": "Ecuador"
  },
  {
    "label": "Egypt",
    "value": "Egypt"
  },
  {
    "label": "El Salvador",
    "value": "El Salvador"
  },
  {
    "label": "Equatorial Guinea",
    "value": "Equatorial Guinea"
  },
  {
    "label": "Eritrea",
    "value": "Eritrea"
  },
  {
    "label": "Estonia",
    "value": "Estonia"
  },
  {
    "label": "swatini",
    "value": "swatini"
  },
  {
    "label": "Ethiopia",
    "value": "Ethiopia"
  },
  {
    "label": "Fiji",
    "value": "Fiji"
  },
  {
    "label": "Finland",
    "value": "Finland"
  },
  {
    "label": "France",
    "value": "France"
  },
  {
    "label": "Gabon",
    "value": "Gabon"
  },
  {
    "label": "Gambia",
    "value": "Gambia"
  },
  {
    "label": "Georgia",
    "value": "Georgia"
  },
  {
    "label": "Germany",
    "value": "Germany"
  },
  {
    "label": "Ghana",
    "value": "Ghana"
  },
  {
    "label": "Greece",
    "value": "Greece"
  },
  {
    "label": "Grenada",
    "value": "Grenada"
  },
  {
    "label": "Guatemala",
    "value": "Guatemala"
  },
  {
    "label": "Guinea",
    "value": "Guinea"
  },
  {
    "label": "Guinea-Bissau",
    "value": "Guinea-Bissau"
  },
  {
    "label": "Guyana",
    "value": "Guyana"
  },
  {
    "label": "Haiti",
    "value": "Haiti"
  },
  {
    "label": "Honduras",
    "value": "Honduras"
  },
  {
    "label": "Hungary",
    "value": "Hungary"
  },
  {
    "label": "Iceland",
    "value": "Iceland"
  },
  {
    "label": "India",
    "value": "India"
  },
  {
    "label": "Indonesia",
    "value": "Indonesia"
  },
  {
    "label": "Iran",
    "value": "Iran"
  },
  {
    "label": "Iraq",
    "value": "Iraq"
  },
  {
    "label": "Ireland",
    "value": "Ireland"
  },
  {
    "label": "Israel",
    "value": "Israel"
  },
  {
    "label": "Italy",
    "value": "Italy"
  },
  {
    "label": "Ivory Coast",
    "value": "Ivory Coast"
  },
  {
    "label": "Jamaica",
    "value": "Jamaica"
  },
  {
    "label": "Japan",
    "value": "Japan"
  },
  {
    "label": "Jordan",
    "value": "Jordan"
  },
  {
    "label": "Kazakhstan",
    "value": "Kazakhstan"
  },
  {
    "label": "Kenya",
    "value": "Kenya"
  },
  {
    "label": "Kiribati",
    "value": "Kiribati"
  },
  {
    "label": "Kuwait",
    "value": "Kuwait"
  },
  {
    "label": "Kyrgyzstan",
    "value": "Kyrgyzstan"
  },
  {
    "label": "Laos",
    "value": "Laos"
  },
  {
    "label": "Latvia",
    "value": "Latvia"
  },
  {
    "label": "Lebanon",
    "value": "Lebanon"
  },
  {
    "label": "Lesotho",
    "value": "Lesotho"
  },
  {
    "label": "Liberia",
    "value": "Liberia"
  },
  {
    "label": "Libya",
    "value": "Libya"
  },
  {
    "label": "Liechtenstein",
    "value": "Liechtenstein"
  },
  {
    "label": "Lithuania",
    "value": "Lithuania"
  },
  {
    "label": "Luxembourg",
    "value": "Luxembourg"
  },
  {
    "label": "Madagascar",
    "value": "Madagascar"
  },
  {
    "label": "Malawi",
    "value": "Malawi"
  },
  {
    "label": "Malaysia",
    "value": "Malaysia"
  },
  {
    "label": "Maldives",
    "value": "Maldives"
  },
  {
    "label": "Mali",
    "value": "Mali"
  },
  {
    "label": "Malta",
    "value": "Malta"
  },
  {
    "label": "Marshall Islands",
    "value": "Marshall Islands"
  },
  {
    "label": "Mauritania",
    "value": "Mauritania"
  },
  {
    "label": "Mauritius",
    "value": "Mauritius"
  },
  {
    "label": "Mexico",
    "value": "Mexico"
  },
  {
    "label": "Micronesia",
    "value": "Micronesia"
  },
  {
    "label": "Moldova",
    "value": "Moldova"
  },
  {
    "label": "Monaco",
    "value": "Monaco"
  },
  {
    "label": "Mongolia",
    "value": "Mongolia"
  },
  {
    "label": "Montenegro",
    "value": "Montenegro"
  },
  {
    "label": "Morocco",
    "value": "Morocco"
  },
  {
    "label": "Mozambique",
    "value": "Mozambique"
  },
  {
    "label": "Myanmar",
    "value": "Myanmar"
  },
  {
    "label": "Namibia",
    "value": "Namibia"
  },
  {
    "label": "Nauru",
    "value": "Nauru"
  },
  {
    "label": "Nepal",
    "value": "Nepal"
  },
  {
    "label": "Netherlands",
    "value": "Netherlands"
  },
  {
    "label": "New Zealand",
    "value": "New Zealand"
  },
  {
    "label": "Nicaragua",
    "value": "Nicaragua"
  },
  {
    "label": "Niger",
    "value": "Niger"
  },
  {
    "label": "Nigeria",
    "value": "Nigeria"
  },
  {
    "label": "North Korea",
    "value": "North Korea"
  },
  {
    "label": "North Macedonia",
    "value": "North Macedonia"
  },
  {
    "label": "Norway",
    "value": "Norway"
  },
  {
    "label": "Oman",
    "value": "Oman"
  },
  {
    "label": "Pakistan",
    "value": "Pakistan"
  },
  {
    "label": "Palau",
    "value": "Palau"
  },
  {
    "label": "Panama",
    "value": "Panama"
  },
  {
    "label": "Papua New Guinea",
    "value": "Papua New Guinea"
  },
  {
    "label": "Paraguay",
    "value": "Paraguay"
  },
  {
    "label": "Peru",
    "value": "Peru"
  },
  {
    "label": "Philippines",
    "value": "Philippines"
  },
  {
    "label": "Poland",
    "value": "Poland"
  },
  {
    "label": "Portugal",
    "value": "Portugal"
  },
  {
    "label": "Qatar",
    "value": "Qatar"
  },
  {
    "label": "Romania",
    "value": "Romania"
  },
  {
    "label": "Russia",
    "value": "Russia"
  },
  {
    "label": "Rwanda",
    "value": "Rwanda"
  },
  {
    "label": "Saint Kitts and Nevis",
    "value": "Saint Kitts and Nevis"
  },
  {
    "label": "Saint Lucia",
    "value": "Saint Lucia"
  },
  {
    "label": "Saint Vincent and the Grenadines",
    "value": "Saint Vincent and the Grenadines"
  },
  {
    "label": "Samoa",
    "value": "Samoa"
  },
  {
    "label": "San Marino",
    "value": "San Marino"
  },
  {
    "label": "Sao Tome and Principe",
    "value": "Sao Tome and Principe"
  },
  {
    "label": "Saudi Arabia",
    "value": "Saudi Arabia"
  },
  {
    "label": "Senegal",
    "value": "Senegal"
  },
  {
    "label": "Serbia",
    "value": "Serbia"
  },
  {
    "label": "Seychelles",
    "value": "Seychelles"
  },
  {
    "label": "Sierra Leone",
    "value": "Sierra Leone"
  },
  {
    "label": "Singapore",
    "value": "Singapore"
  },
  {
    "label": "Slovakia",
    "value": "Slovakia"
  },
  {
    "label": "Slovenia",
    "value": "Slovenia"
  },
  {
    "label": "Solomon Islands",
    "value": "Solomon Islands"
  },
  {
    "label": "Somalia",
    "value": "Somalia"
  },
  {
    "label": "South Africa",
    "value": "South Africa"
  },
  {
    "label": "South Korea",
    "value": "South Korea"
  },
  {
    "label": "South Sudan",
    "value": "South Sudan"
  },
  {
    "label": "Spain",
    "value": "Spain"
  },
  {
    "label": "Sri Lanka",
    "value": "Sri Lanka"
  },
  {
    "label": "Sudan",
    "value": "Sudan"
  },
  {
    "label": "Suriname",
    "value": "Suriname"
  },
  {
    "label": "Sweden",
    "value": "Sweden"
  },
  {
    "label": "Switzerland",
    "value": "Switzerland"
  },
  {
    "label": "Syria",
    "value": "Syria"
  },
  {
    "label": "Tajikistan",
    "value": "Tajikistan"
  },
  {
    "label": "Tanzania",
    "value": "Tanzania"
  },
  {
    "label": "Thailand",
    "value": "Thailand"
  },
  {
    "label": "Timor-Leste",
    "value": "Timor-Leste"
  },
  {
    "label": "Togo",
    "value": "Togo"
  },
  {
    "label": "Tonga",
    "value": "Tonga"
  },
  {
    "label": "Trinidad and Tobago",
    "value": "Trinidad and Tobago"
  },
  {
    "label": "Tunisia",
    "value": "Tunisia"
  },
  {
    "label": "Turkey",
    "value": "Turkey"
  },
  {
    "label": "Turkmenistan",
    "value": "Turkmenistan"
  },
  {
    "label": "Tuvalu",
    "value": "Tuvalu"
  },
  {
    "label": "Uganda",
    "value": "Uganda"
  },
  {
    "label": "Ukraine",
    "value": "Ukraine"
  },
  {
    "label": "United Arab Emirates",
    "value": "United Arab Emirates"
  },
  {
    "label": "United Kingdom",
    "value": "United Kingdom"
  },
  {
    "label": "United States Of America",
    "value": "United States Of America"
  },
  {
    "label": "Uruguay",
    "value": "Uruguay"
  },
  {
    "label": "Uzbekistan",
    "value": "Uzbekistan"
  },
  {
    "label": "Vanuatu",
    "value": "Vanuatu"
  },
  {
    "label": "Venezuela",
    "value": "Venezuela"
  },
  {
    "label": "Vietnam",
    "value": "Vietnam"
  },
  {
    "label": "Yemen",
    "value": "Yemen"
  },
  {
    "label": "Zambia",
    "value": "Zambia"
  },
  {
    "label": "Zimbabwe",
    "value": "Zimbabwe"
  }
];

export const PHONE_CODE_OPTIONS = [
  { "label": "+93", "value": "+93" },
  { "label": "+358", "value": "+358" },
  { "label": "+355", "value": "+355" },
  { "label": "+213", "value": "+213" },
  { "label": "+1684", "value": "+1684" },
  { "label": "+376", "value": "+376" },
  { "label": "+244", "value": "+244" },
  { "label": "+1264", "value": "+1264" },
  { "label": "+672", "value": "+672" },
  { "label": "+1268", "value": "+1268" },
  { "label": "+54", "value": "+54" },
  { "label": "+374", "value": "+374" },
  { "label": "+297", "value": "+297" },
  { "label": "+61", "value": "+61" },
  { "label": "+43", "value": "+43" },
  { "label": "+994", "value": "+994" },
  { "label": "+1242", "value": "+1242" },
  { "label": "+973", "value": "+973" },
  { "label": "+880", "value": "+880" },
  { "label": "+1246", "value": "+1246" },
  { "label": "+375", "value": "+375" },
  { "label": "+32", "value": "+32" },
  { "label": "+501", "value": "+501" },
  { "label": "+229", "value": "+229" },
  { "label": "+1441", "value": "+1441" },
  { "label": "+975", "value": "+975" },
  { "label": "+591", "value": "+591" },
  { "label": "+387", "value": "+387" },
  { "label": "+267", "value": "+267" },
  { "label": "+55", "value": "+55" },
  { "label": "+246", "value": "+246" },
  { "label": "+673", "value": "+673" },
  { "label": "+359", "value": "+359" },
  { "label": "+226", "value": "+226" },
  { "label": "+257", "value": "+257" },
  { "label": "+855", "value": "+855" },
  { "label": "+237", "value": "+237" },
  { "label": "+1", "value": "+1" },
  { "label": "+238", "value": "+238" },
  { "label": "+ 345", "value": "+ 345" },
  { "label": "+236", "value": "+236" },
  { "label": "+235", "value": "+235" },
  { "label": "+56", "value": "+56" },
  { "label": "+86", "value": "+86" },
  { "label": "+61", "value": "+61" },
  { "label": "+61", "value": "+61" },
  { "label": "+57", "value": "+57" },
  { "label": "+269", "value": "+269" },
  { "label": "+242", "value": "+242" },
  { "label": "+243", "value": "+243" },
  { "label": "+682", "value": "+682" },
  { "label": "+506", "value": "+506" },
  { "label": "+225", "value": "+225" },
  { "label": "+385", "value": "+385" },
  { "label": "+53", "value": "+53" },
  { "label": "+357", "value": "+357" },
  { "label": "+420", "value": "+420" },
  { "label": "+45", "value": "+45" },
  { "label": "+253", "value": "+253" },
  { "label": "+1767", "value": "+1767" },
  { "label": "+1849", "value": "+1849" },
  { "label": "+593", "value": "+593" },
  { "label": "+20", "value": "+20" },
  { "label": "+503", "value": "+503" },
  { "label": "+240", "value": "+240" },
  { "label": "+291", "value": "+291" },
  { "label": "+372", "value": "+372" },
  { "label": "+251", "value": "+251" },
  { "label": "+500", "value": "+500" },
  { "label": "+298", "value": "+298" },
  { "label": "+679", "value": "+679" },
  { "label": "+358", "value": "+358" },
  { "label": "+33", "value": "+33" },
  { "label": "+594", "value": "+594" },
  { "label": "+689", "value": "+689" },
  { "label": "+241", "value": "+241" },
  { "label": "+220", "value": "+220" },
  { "label": "+995", "value": "+995" },
  { "label": "+49", "value": "+49" },
  { "label": "+233", "value": "+233" },
  { "label": "+350", "value": "+350" },
  { "label": "+30", "value": "+30" },
  { "label": "+299", "value": "+299" },
  { "label": "+1473", "value": "+1473" },
  { "label": "+590", "value": "+590" },
  { "label": "+1671", "value": "+1671" },
  { "label": "+502", "value": "+502" },
  { "label": "+44", "value": "+44" },
  { "label": "+224", "value": "+224" },
  { "label": "+245", "value": "+245" },
  { "label": "+595", "value": "+595" },
  { "label": "+509", "value": "+509" },
  { "label": "+379", "value": "+379" },
  { "label": "+504", "value": "+504" },
  { "label": "+852", "value": "+852" },
  { "label": "+36", "value": "+36" },
  { "label": "+354", "value": "+354" },
  { "label": "+91", "value": "+91" },
  { "label": "+62", "value": "+62" },
  { "label": "+98", "value": "+98" },
  { "label": "+964", "value": "+964" },
  { "label": "+353", "value": "+353" },
  { "label": "+44", "value": "+44" },
  { "label": "+972", "value": "+972" },
  { "label": "+39", "value": "+39" },
  { "label": "+1876", "value": "+1876" },
  { "label": "+81", "value": "+81" },
  { "label": "+44", "value": "+44" },
  { "label": "+962", "value": "+962" },
  { "label": "+77", "value": "+77" },
  { "label": "+254", "value": "+254" },
  { "label": "+686", "value": "+686" },
  { "label": "+850", "value": "+850" },
  { "label": "+82", "value": "+82" },
  { "label": "+965", "value": "+965" },
  { "label": "+996", "value": "+996" },
  { "label": "+856", "value": "+856" },
  { "label": "+371", "value": "+371" },
  { "label": "+961", "value": "+961" },
  { "label": "+266", "value": "+266" },
  { "label": "+231", "value": "+231" },
  { "label": "+218", "value": "+218" },
  { "label": "+423", "value": "+423" },
  { "label": "+370", "value": "+370" },
  { "label": "+352", "value": "+352" },
  { "label": "+853", "value": "+853" },
  { "label": "+389", "value": "+389" },
  { "label": "+261", "value": "+261" },
  { "label": "+265", "value": "+265" },
  { "label": "+60", "value": "+60" },
  { "label": "+960", "value": "+960" },
  { "label": "+223", "value": "+223" },
  { "label": "+356", "value": "+356" },
  { "label": "+692", "value": "+692" },
  { "label": "+596", "value": "+596" },
  { "label": "+222", "value": "+222" },
  { "label": "+230", "value": "+230" },
  { "label": "+262", "value": "+262" },
  { "label": "+52", "value": "+52" },
  { "label": "+691", "value": "+691" },
  { "label": "+373", "value": "+373" },
  { "label": "+377", "value": "+377" },
  { "label": "+976", "value": "+976" },
  { "label": "+382", "value": "+382" },
  { "label": "+1664", "value": "+1664" },
  { "label": "+212", "value": "+212" },
  { "label": "+258", "value": "+258" },
  { "label": "+95", "value": "+95" },
  { "label": "+264", "value": "+264" },
  { "label": "+674", "value": "+674" },
  { "label": "+977", "value": "+977" },
  { "label": "+31", "value": "+31" },
  { "label": "+599", "value": "+599" },
  { "label": "+687", "value": "+687" },
  { "label": "+64", "value": "+64" },
  { "label": "+505", "value": "+505" },
  { "label": "+227", "value": "+227" },
  { "label": "+234", "value": "+234" },
  { "label": "+683", "value": "+683" },
  { "label": "+672", "value": "+672" },
  { "label": "+1670", "value": "+1670" },
  { "label": "+47", "value": "+47" },
  { "label": "+968", "value": "+968" },
  { "label": "+92", "value": "+92" },
  { "label": "+680", "value": "+680" },
  { "label": "+970", "value": "+970" },
  { "label": "+507", "value": "+507" },
  { "label": "+675", "value": "+675" },
  { "label": "+595", "value": "+595" },
  { "label": "+51", "value": "+51" },
  { "label": "+63", "value": "+63" },
  { "label": "+872", "value": "+872" },
  { "label": "+48", "value": "+48" },
  { "label": "+351", "value": "+351" },
  { "label": "+1939", "value": "+1939" },
  { "label": "+974", "value": "+974" },
  { "label": "+40", "value": "+40" },
  { "label": "+7", "value": "+7" },
  { "label": "+250", "value": "+250" },
  { "label": "+262", "value": "+262" },
  { "label": "+590", "value": "+590" },
  { "label": "+290", "value": "+290" },
  { "label": "+1869", "value": "+1869" },
  { "label": "+1758", "value": "+1758" },
  { "label": "+590", "value": "+590" },
  { "label": "+508", "value": "+508" },
  { "label": "+1784", "value": "+1784" },
  { "label": "+685", "value": "+685" },
  { "label": "+378", "value": "+378" },
  { "label": "+239", "value": "+239" },
  { "label": "+966", "value": "+966" },
  { "label": "+221", "value": "+221" },
  { "label": "+381", "value": "+381" },
  { "label": "+248", "value": "+248" },
  { "label": "+232", "value": "+232" },
  { "label": "+65", "value": "+65" },
  { "label": "+421", "value": "+421" },
  { "label": "+386", "value": "+386" },
  { "label": "+677", "value": "+677" },
  { "label": "+252", "value": "+252" },
  { "label": "+27", "value": "+27" },
  { "label": "+211", "value": "+211" },
  { "label": "+500", "value": "+500" },
  { "label": "+34", "value": "+34" },
  { "label": "+94", "value": "+94" },
  { "label": "+249", "value": "+249" },
  { "label": "+597", "value": "+597" },
  { "label": "+47", "value": "+47" },
  { "label": "+268", "value": "+268" },
  { "label": "+46", "value": "+46" },
  { "label": "+41", "value": "+41" },
  { "label": "+963", "value": "+963" },
  { "label": "+886", "value": "+886" },
  { "label": "+992", "value": "+992" },
  { "label": "+255", "value": "+255" },
  { "label": "+66", "value": "+66" },
  { "label": "+670", "value": "+670" },
  { "label": "+228", "value": "+228" },
  { "label": "+690", "value": "+690" },
  { "label": "+676", "value": "+676" },
  { "label": "+1868", "value": "+1868" },
  { "label": "+216", "value": "+216" },
  { "label": "+90", "value": "+90" },
  { "label": "+993", "value": "+993" },
  { "label": "+1649", "value": "+1649" },
  { "label": "+688", "value": "+688" },
  { "label": "+256", "value": "+256" },
  { "label": "+380", "value": "+380" },
  { "label": "+971", "value": "+971" },
  { "label": "+44", "value": "+44" },
  { "label": "+1", "value": "+1" },
  { "label": "+598", "value": "+598" },
  { "label": "+998", "value": "+998" },
  { "label": "+678", "value": "+678" },
  { "label": "+58", "value": "+58" },
  { "label": "+84", "value": "+84" },
  { "label": "+1284", "value": "+1284" },
  { "label": "+1340", "value": "+1340" },
  { "label": "+681", "value": "+681" },
  { "label": "+967", "value": "+967" },
  { "label": "+260", "value": "+260" },
  {
    "label": "+263", "value": "+263"
  }
]

export const MAX_DATE = new Date();

export const QUESTION_TYPES = [
  { label: "Text box", value: "TextBox" },
  { label: "Text area", value: "TextArea" },
  { label: "Drop-down", value: "Dropdown" },
  { label: "Checkbox", value: "Checkbox" },
  { label: "Date picker", value: "DatePicker" },
  { label: "Multi-select", value: "MultiSelect" },
  { label: "Radio", value: "Radio" },
];

export const CASE_TYPE_MAPPING = {
  STAGES: "stages",
  QUESTIONNAIRE: "questionnaire",
  DOCUMENTS: "documents",
  FORMS: "forms",
  QUESTIONNAIRE_MAPPING: "questionnaire-mapping",
  FORM_MAPPING: "form-mapping"
};

export const LANGUAGES_OPTIONS = [
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" },
  { label: "Portuguese", value: "Portuguese" },
  { label: "Other", value: "Other" },
];

export const PRIORITY_OPTIONS = [
  { label: "Low", value: "Low" },
  { label: "Normal", value: "Normal" },
  { label: "High", value: "High" },
];

export const REMINDER_OPTIONS = [
  { label: "No reminder", value: "0" },
  { label: "2 days", value: "2" },
  { label: "4 days", value: "4" },
  { label: "7 days", value: "7" },
];

export const UNSAVED_CHANGES_INFO = "Are you sure you want to leave, You have unsaved changes?";

export const APARTMENT_TYPES = [
  { label: "Apt.", value: "Apt." },
  { label: "Door", value: "Door" },
  { label: "Floor", value: "Floor" },
  { label: "Suite", value: "Suite" },
  { label: "Unit", value: "Unit" },
];

export const RELATIONSHIP_OPTIONS = [
  { label: "Wife", value: "Wife" },
  { label: "Husband", value: "Husband" },
  { label: "Former spouse", value: "Former spouse" },
  { label: "Child", value: "Child" },
  { label: "Son", value: "Son" },
  { label: "Daughter", value: "Daughter" },
  { label: "Stepson", value: "Stepson" },
  { label: "Stepdaughter", value: "Stepdaughter" },
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Brother", value: "Brother" },
  { label: "Sister", value: "Sister" },
  { label: "Fiance/Fiancee", value: "Fiance/Fiancee" },
  { label: "Son-in-Law", value: "Son-in-Law" },
  { label: "Daughter-In-Law", value: "Daughter-In-Law" },
  { label: "Brother-in-Law", value: "Brother-in-Law" },
  { label: "Sister-in-Law", value: "Sister-in-Law" },
  { label: "Common Law Partner", value: "Common Law Partner" },
  { label: "Domestic Partner", value: "Domestic Partner" },
  { label: "Caregiver", value: "Caregiver" },
  { label: "Legal Guardian", value: "Legal Guardian" },
  { label: "Other", value: "Other" },
  { label: "Co-applicant", value: "Co-applicant" },
];

export const APPLICANT_OPTIONS = [
  { label: "Main Applicant", value: "Main Applicant" },
  { label: "Wife", value: "Wife" },
  { label: "Husband", value: "Husband" },
  { label: "Former spouse", value: "Former spouse" },
  { label: "Child", value: "Child" },
  { label: "Son", value: "Son" },
  { label: "Daughter", value: "Daughter" },
  { label: "Stepson", value: "Stepson" },
  { label: "Stepdaughter", value: "Stepdaughter" },
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Brother", value: "Brother" },
  { label: "Sister", value: "Sister" },
  { label: "Fiance/Fiancee", value: "Fiance/Fiancee" },
  { label: "Son-in-Law", value: "Son-in-Law" },
  { label: "Daughter-In-Law", value: "Daughter-In-Law" },
  { label: "Brother-in-Law", value: "Brother-in-Law" },
  { label: "Sister-in-Law", value: "Sister-in-Law" },
  { label: "Common Law Partner", value: "Common Law Partner" },
  { label: "Domestic Partner", value: "Domestic Partner" },
  { label: "Caregiver", value: "Caregiver" },
  { label: "Legal Guardian", value: "Legal Guardian" },
  { label: "Other", value: "Other" },
  { label: "Co-applicant", value: "Co-applicant" },
  { label: "Sponsor", value: "Sponsor" },
];

export const SELECT_ONE_NOTE = "Select atleast one record to export"

// Case Tabs ID
export const CASE_TABS_ID = {
  CLIENT_DETAILS: 'clientDetails',
  COMMUNICATION: 'communication',
  EMAILS: 'emails',
  DRAFTS: 'drafts',
  COMPOSE_EMAIL: 'composeEmail',
  PIPE_NOTES: 'pipeNotes',
  ALL_CASES: 'allCases',
  BILLING: 'billing',
  ALERTS: 'alerts',
};

// Case Tabs ID
export const COMAPNY_TABS_ID = {
  COMPANY_DETAILS: 'companyDetails',
  ALL_CASES: 'allCases',
  ALERTS: 'alerts',
};

export const ALERTS_TYPES = [
  { label: "Red", value: "Red" },
  { label: "Green", value: "Green" },
  { label: "Orange", value: "Orange" },
];

export const MODE_OF_CREATION_OPTIONS = [
  { label: "Mode of Creation: All", value: "" },
  { label: "PipeDrive", value: "PipeDrive" },
  { label: "CHWizard(or Manual)", value: "Manual" }
];

export const BILLING_STATUS_OPTIONS = [
  { label: "None", value: "None" },
  { label: "Overdue", value: "Overdue" },
  { label: "On time", value: "On time" }
];

export const MAIN_CONTACTS_OPTIONS = [
  { label: "Main Contact: All", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" }
];

export const CASE_STATUS_OPTIONS = [
  { label: "Case Status: All", value: "" },
  { label: "Open", value: "Open" },
  { label: "Close", value: "Closed" }
];

export const CASE_STATUS_WITH_NA_OPTIONS = [
  { label: "Case Status: All", value: "" },
  { label: "Open", value: "Open" },
  { label: "Closed", value: "Closed" },
  { label: "None", value: "N/A" },
];

export const CURRENTLY_IN_US_OPTIONS = [
  { label: "Currently in US: All", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" }
];


// Roles heading
export const TEAMS_PERMISSION_HEADING = "Manage Team";
export const USERS_PERMISSION_HEADING = "Manage User";
export const DERIVATIVE_ACTION = {
  Send: {
    title: "Send Questionnaire",
    body: "Are you sure, you want to Send the Questionnaire?"
  },
  Completed: {
    title: "Complete Questionnaire",
    body: "Are you sure, you want to Complete the Questionnaire?"
  },
  Reviewed: {
    title: "Review Questionnaire",
    body: "Are you sure, you want to Review the Questionnaire?"
  },
  Resend: {
    title: "Resend Questionnaire",
    body: "Are you sure, you want to Resend the Questionnaire?"
  }
}
export const KB_PERMISSION_STAGES = "Knowledge Base Manage Stages";
export const KB_PERMISSION_STEPS = "Knowledge Base Manage Steps";
export const KB_PERMISSION_DOC_CHECK_ITEMS = "Knowledge Base Manage Document Checklist Items";
export const KB_PERMISSION_DOC_CHECKLIST = "Knowledge Base Manage Document Checklist";
export const KB_PERMISSION_DOC_TYPE = "Knowledge Base Manage Document Type";
export const KB_PERMISSION_DOCUMENT = "Knowledge Base Manage Document";
export const KB_PERMISSION_FORMS = "Knowledge Base Manage Forms";
export const KB_PERMISSION_EMAIL_TEMP = "Knowledge Base Manage Email Templates";
export const KB_PERMISSION_QUESTION = "Knowledge Base Manage Questions";
export const KB_PERMISSION_QUESTIONNAIRE = "Knowledge Base Manage Questionnaires";
export const PERMISSION_RBAC = "You don't have permission to perform this action.";
export const CLIENT_MANAGEMENT_PERMISSION_LISTING = "Client Management Listing";
export const CLIENT_MANAGEMENT_PERMISSION_RELATIVES = "Client Management Relatives";
export const CLIENT_MANAGEMENT_PERMISSION_COMMUNICATION = "Client Management Communication";
export const CLIENT_MANAGEMENT_PERMISSION_NOTES = "Client Management Notes";
export const CLIENT_MANAGEMENT_PERMISSION_BILLING = "Client Management Billing";
export const CLIENT_MANAGEMENT_PERMISSION_CASE = "Client Management Case";
export const CLIENT_MANAGEMENT_PERMISSION_ALERTS = "Client Management Alerts";
export const CASE_TYPE_MANAGEMENT_PERMISSION = "Case Type Management Manage Case Type";
export const CASE_TYPE_MANAGEMENT_PERMISSION_FORMS = "Case Type Management Manage Case Type-Forms";
export const CASE_TYPE_MANAGEMENT_PERMISSION_DOCUMENT = "Case Type Management Manage Case Type-Document";
export const CASE_TYPE_MANAGEMENT_PERMISSION_QUESTIONNAIRE = "Case Type Management Manage Case Type-Questionnairs";
export const CASE_TYPE_MANAGEMENT_PERMISSION_STAGES_STEPS = "Case Type Management Manage Case Type-Stages(Steps)";
export const CASE_MANAGEMENT_PERMISSION_LISTING = "Case Management Listing";
export const CASE_MANAGEMENT_PERMISSION_RECEIPT = "Case Management Receipt";
export const CASE_MANAGEMENT_PERMISSION_DERIVATIVE_COAPPLICANT = "Case Management Derivative/Co-Applicant";
export const CASE_MANAGEMENT_PERMISSION_FILING_DETAIL = "Case Management Filing Detail";
export const CASE_MANAGEMENT_PERMISSION_CASE_INFO_DETAIL = "Case Management Case Info Detail";
export const CASE_MANAGEMENT_PERMISSION_STAGE_AND_STEPS = "Case Management Stage and Steps";
export const CASE_MANAGEMENT_PERMISSION_NOTES = "Case Management Notes";
export const CASE_MANAGEMENT_PERMISSION_DOCUMENT_CHECKLIST = "Case Management Document Checklist";
export const CASE_MANAGEMENT_PERMISSION_DOCUMENT_LISTING = "Case Management Document Listing";
export const CASE_MANAGEMENT_PERMISSION_QUESTIONNAIRS_LISTING = "Case Management Questionnairs Listing";
export const CASE_MANAGEMENT_PERMISSION_FORMS_LISTING = "Case Management Forms Listing";
export const CASE_MANAGEMENT_PERMISSION_REMINDER_LISTING = "Case Management Reminder";
export const CASE_MANAGEMENT_PERMISSION_EVENT_LISTING = "Case Management Event";
export const USER_MANAGEMENT_PERMISSION_MANAGE_DESIGNATION = "Manage Designations";
export const SETTINGS_PERMISSION = "Settings";
export const REPORTS_PERMISSION_GENERATE_NEW_REPORT = "Generate New Report";
export const REPORTS_PERMISSION_SAVED_REPORT = "Saved Reports";
export const DASHBOARD_PERMISSION = "Dashboard";
export const COMPANY_MANAGEMENT_LISTING_PERMISSION = "Company Management Listing";  
export const COMPANY_MANAGEMENT_PERMISSION_ALERTS = "Company Management Alert";
export const COMPANY_MANAGEMENT_PERMISSION_ALL_CASES = "Company Management View All Cases";



// --------- Folder Structure Starts from here ----------------

export const AOS_FOLDERS = [
  {
    label: "A. CH files and scans",
    code: "AOSACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "AOSBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "AOSCAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "AOSDT",
    items: [
      { label: "D. Translations", value: "D. Translations;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "AOSEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "AOSFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Medical Examination",
    code: "AOSGME",
    items: [
      {
        label: "G. Medical Examination",
        value: "G. Medical Examination;G. Medical Examination",
      },
    ],
  },
  {
    label: "H. Photos",
    code: "AOSGME",
    items: [{ label: "H. Photos", value: "H. Photos;H. Photos" }],
  },
  {
    label: "I. Inquiries to USCIS",
    code: "AOSIITU",
    items: [
      {
        label: "I. Inquiries to USCIS",
        value: "I. Inquiries to USCIS;I. Inquiries to USCIS",
      },
    ],
  },
  {
    label: "J. Inquiries to Ombudsman",
    code: "AOSJITQ",
    items: [
      {
        label: "J. Inquiries to Ombudsman",
        value: "J. Inquiries to Ombudsman;J. Inquiries to Ombudsman",
      },
    ],
  },
  {
    label: "K. Change of Address",
    code: "AOSKCOA",
    items: [
      {
        label: "K. Change of Address",
        value: "K. Change of Address;K. Change of Address",
      },
    ],
  },
  {
    label: "L. Documents received from USCIS",
    code: "AOSLDRFU",
    items: [
      { label: "EAD", value: "EAD;L. Documents received from USCIS" },
      {
        label: "Green card",
        value: "Green card;L. Documents received from USCIS",
      },
      { label: "I-512", value: "I-512;L. Documents received from USCIS" },
    ],
  },
  {
    label: "M. RFE",
    code: "AOSMRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;M. RFE" },
      { label: "RFE Response", value: "RFE Response;M. RFE" },
    ],
  },
  {
    label: "N. NOID",
    code: "AOSNN",
    items: [
      { label: "NOID documents", value: "NOID documents;N. NOID" },
      { label: "NOID Response", value: "NOID Response;N. NOID" },
    ],
  },
  {
    label: "O. Withdrawal",
    code: "AOSOW",
    items: [{ label: "O. Withdrawal", value: "O. Withdrawal;O. Withdrawal" }],
  },
  {
    label: "P. Others",
    code: "AOSPO",
    items: [{ label: "P. Others", value: "P. Others;P. Others" }],
  },
];

export const CP_Folders = [
  {
    label: 'A. CH files and scans',
    code: 'CPACHFAS',
    items: [
      { label: 'A. CH files and scans', value: 'A. CH files and scans;A. CH files and scans' },
    ]
  },
  {
    label: 'B. Client uploaded files',
    code: 'CPBCUF',
    items: [
      { label: 'B. Client uploaded files', value: 'B. Client uploaded files;B. Client uploaded files' },
    ]
  },
  {
    label: 'C. NVC Packages',
    code: 'CPCNVCP',
    items: [
      { label: 'C. NVC Packages', value: 'C. NVC Packages;C. NVC Packages' },
    ]
  },
  {
    label: 'D. Translations',
    code: 'CPDT',
    items: [
      { label: 'D. Translations', value: 'D. Translations;D. Translations' },
    ]
  },
  {
    label: 'E. Forms',
    code: 'CPEF',
    items: [
      { label: 'E. Forms', value: 'E. Forms;E. Forms' },
    ]
  },
  {
    label: 'F. DS-260 Confirmation Page',
    code: 'CPFDSCP',
    items: [
      { label: 'F. DS-260 Confirmation Page', value: 'F. DS-260 Confirmation Page;F. DS-260 Confirmation Page' },
    ]
  },
  {
    label: 'G. Notices from NVC',
    code: 'CPGNfNVC',
    items: [
      { label: 'Case Number and Invoice', value: 'Case Number and Invoice;G. Notices from NVC' },
      { label: 'Documentarily Complete', value: 'Documentarily Complete;G. Notices from NVC' },
      { label: 'Payment receipts', value: 'Payment receipts;G. Notices from NVC' },
    ]
  },
  {
    label: 'H. RFE',
    code: 'CPHRFE',
    items: [
      { label: 'RFE documents', value: 'RFE documents;H. RFE' },
      { label: 'RFE Response', value: 'RFE Response;H. RFE' },
    ]
  },
  {
    label: 'I. Inquiries to NVC',
    code: 'CPIITNVC',
    items: [
      { label: 'I. Inquiries to NVC', value: 'I. Inquiries to NVC;I. Inquiries to NVC' },
    ]
  },
  {
    label: 'J. Consular Interview and documents',
    code: 'CPJCIAD',
    items: [
      { label: 'J. Consular Interview and documents', value: 'J. Consular Interview and documents;J. Consular Interview and documents' },
    ]
  },
  {
    label: 'K. Others',
    code: 'CPKO',
    items: [
      { label: 'K. Others', value: 'K. Others;K. Others' },
    ]
  },
  
];

export const E1 = [
  {
    label: 'A. CH files and scans',
    code: 'E1ACHFAS',
    items: [
      { label: 'Filing Fee', value: 'Filing Fee;A. CH files and scans' },
      { label: 'From Onboarding', value: 'From Onboarding;A. CH files and scans' },
      { label: 'Notices from USCIS (Receipt, Approval, Denial)', value: 'Notices from USCIS (Receipt, Approval, Denial);A. CH files and scans' },
    ]
  },
  {
    label: 'B. Client uploaded files',
    code: 'E1BCUF',
    items: [
      { label: 'B. Client uploaded files', value: 'B. Client uploaded files;B. Client uploaded files' },
    ]
  },
  {
    label: 'C. Application package',
    code: 'E1CAP',
    items: [
      { label: 'C. Application package', value: 'C. Application package;C. Application package' },
    ]
  },
  {
    label: 'D. Biographic documents',
    code: 'E1DBD',
    items: [
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Change or extensions of status granted', value: 'Change or extensions of status granted;D. Biographic documents' },
      { label: 'I-94s', value: 'I-94s;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Passports', value: 'Passports;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
      { label: 'Visas', value: 'Visas;D. Biographic documents' },
    ]
  },
  {
    label: 'E. Forms',
    code: 'E1EF',
    items: [
      { label: 'E. Forms', value: 'E. Forms;E. Forms' },
    ]
  },
  {
    label: 'F. Evidence of foreign residence',
    code: 'E1FEOFR',
    items: [
      { label: 'F. Evidence of foreign residence', value: 'F. Evidence of foreign residence;F. Evidence of foreign residence' },
    ]
  }, 
  {
    label: 'G. Declaration of Intent to Depart the U.S',
    code: 'E1GDOITDTUS',
    items: [
      { label: 'G. Declaration of Intent to Depart the U.S', value: 'G. Declaration of Intent to Depart the U.S;G. Declaration of Intent to Depart the U.S' },
    ]
  },  
  {
    label: 'H. Ownership documents',
    code: 'E1HOD',
    items: [
      { label: 'Articles of Incorporation or Organization', value: 'Articles of Incorporation or Organization;H. Ownership documents' },
      { label: 'Bylaws or Operating Agreement', value: 'Bylaws or Operating Agreement;H. Ownership documents' },
      { label: 'Corporate Tax or Annual Report', value: 'Corporate Tax or Annual Report;H. Ownership documents' },
      { label: 'EIN-Tax ID', value: 'EIN-Tax ID;H. Ownership documents' },
      { label: 'Marketing material', value: 'Marketing material;H. Ownership documents' },
      { label: 'Membership or Share Certificate', value: 'Membership or Share Certificate;H. Ownership documents' },
      { label: 'Organizational Chart', value: 'Organizational Chart;H. Ownership documents' },
      { label: 'Other documents', value: 'Other documents;H. Ownership documents' },
      { label: 'Photos of the business', value: 'Photos of the business;H. Ownership documents' },
    ]
  },
  {
    label: 'I. Substantial Trade',
    code: 'E1IST',
    items: [
      { label: 'Other documents', value: 'Other documents;I. Substantial Trade' },
      { label: 'Purchase invoices', value: 'Purchase invoices;I. Substantial Trade' },
      { label: 'Shipping invoices', value: 'Shipping invoices;I. Substantial Trade' },
      { label: 'Spreedsheet of international trade transactions', value: 'Spreedsheet of international trade transactions;I. Substantial Trade' },
      { label: 'US Corporate Tax Returns', value: 'US Corporate Tax Returns;I. Substantial Trade' },
      { label: 'Wire transfers-payment evidence', value: 'Wire transfers-payment evidence;I. Substantial Trade' },
    ]
  },
  {
    label: 'J. Financial documents',
    code: 'E1JFD',
    items: [
      { label: 'Balance Sheet', value: 'Balance Sheet;J. Financial documents' },
      { label: 'Bank statements', value: 'Bank statements;J. Financial documents' },
      { label: 'Corporate Taxes', value: 'Corporate Taxes;J. Financial documents' },
      { label: 'Profit and Loss (P and L)', value: 'Profit and Loss (P and L);J. Financial documents' },
    ]
  },
  {
    label: 'K. Employee qualifications (degress, certificates)',
    code: 'E1KEQDC',
    items: [
      { label: 'Awards and recognitions', value: 'Awards and recognitions;K. Employee qualifications (degress, certificates)' },
      { label: 'Certificates', value: 'Certificates;K. Employee qualifications (degress, certificates)' },
      { label: 'Curriculum Vitae (CV)', value: 'Curriculum Vitae (CV);K. Employee qualifications (degress, certificates)' },
      { label: 'Diplomas', value: 'Diplomas;K. Employee qualifications (degress, certificates)' },
      { label: 'Licenses', value: 'Licenses;K. Employee qualifications (degress, certificates)' },
      { label: 'Other documents', value: 'Other documents;K. Employee qualifications (degress, certificates)' },
      { label: 'Publications', value: 'Publications;K. Employee qualifications (degress, certificates)' },
    ]
  },
  {
    label: 'L. Job offer letter for Essential Employee',
    code: 'E1LJOLFEE',
    items: [
      { label: 'L. Job offer letter for Essential Employee', value: 'L. Job offer letter for Essential Employee;L. Job offer letter for Essential Employee' },
    ]
  },
  {
    label: 'M. Photos',
    code: 'E1MP',
    items: [
      { label: 'M. Photos', value: 'M. Photos;M. Photos' },
    ]
  },
  {
    label: 'N. Consular Interview and documents',
    code: 'E1NCIAD',
    items: [
      { label: 'N. Consular Interview and documents', value: 'N. Consular Interview and documents;N. Consular Interview and documents' },
    ]
  },
  {
    label: 'O. RFE',
    code: 'E1ORFE',
    items: [
      { label: 'RFE documents', value: 'RFE documents;O. RFE' },
      { label: 'RFE Response', value: 'RFE Response;O. RFE' },
    ]
  },
  {
    label: 'P. NOID',
    code: 'E1PNOID',
    items: [
      { label: 'NOID documents', value: 'NOID documents;P. NOID' },
      { label: 'NOID Response', value: 'NOID Response;P. NOID' },
    ]
  },
  {
    label: 'Q. Withdrawal',
    code: 'E1QW',
    items: [
      { label: 'Q. Withdrawal', value: 'Q. Withdrawal;Q. Withdrawal' },
    ]
  },
  {
    label: 'R. Others',
    code: 'E1RO',
    items: [
      { label: 'R. Others', value: 'R. Others;R. Others' },
    ]
  },
];

export const MANDAMUS = [
  {
      label: 'A. Filings and Court documents',
      code: 'MAFCD',
      items: [
          { label: 'A. Filings and Court documents', value: 'A. Filings and Court documents;A. Filings and Court documents' }
      ]
  },
  {
      label: 'B. AOS',
      code: 'MAAOS',
      items: [
          { label: 'B. AOS', value: 'B. AOS;B. AOS' }
      ]
  },
  {
      label: 'C. I-526',
      code: 'MAI526',
      items: [
          { label: 'C. I-526', value: 'C. I-526;C. I-526' }
      ]
  },
  {
      label: 'D. I-829',
      code: 'MAI829',
      items: [
          { label: 'D. I-829', value: 'D. I-829;D. I-829' }
      ]
  },
  {
      label: 'E. Others',
      code: 'MAOTH',
      items: [
          { label: 'E. Others', value: 'E. Others;E. Others' }
      ]
  },
  {
      label: 'Client Uploaded Documents',
      code: 'CUD',
      items: [
          { label: 'Client Uploaded Documents', value: 'Client Uploaded Documents;Client Uploaded Documents' }
      ]
  },
];

export const E2 =  [
  {
    label: 'A. CH files and scans',
    code: 'E2ACHFAS',
    items: [
      { label: 'Filing Fee', value: 'Filing Fee;A. CH files and scans' },
      { label: 'From Onboarding', value: 'From Onboarding;A. CH files and scans' },
      { label: 'Notices from USCIS (Receipt, Approval, Denial)', value: 'Notices from USCIS (Receipt, Approval, Denial);A. CH files and scans' },
    ]
  },
  {
    label: 'B. Client uploaded files',
    code: 'E2BCUF',
    items: [
      { label: 'B. Client uploaded files', value: 'B. Client uploaded files;B. Client uploaded files' },
    ]
  },
  {
    label: 'C. Application package',
    code: 'E2CAP',
    items: [
      { label: 'C. Application package', value: 'C. Application package;C. Application package' },
    ]
  },
  {
    label: 'D. Biographic documents',
    code: 'E2DBD',
    items: [
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Change or extensions of status granted', value: 'Change or extensions of status granted;D. Biographic documents' },
      { label: 'I-94s', value: 'I-94s;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Passports', value: 'Passports;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
      { label: 'Visas', value: 'Visas;D. Biographic documents' },
    ]
  },
  {
    label: 'E. Forms',
    code: 'E2EF',
    items: [
      { label: 'E. Forms', value: 'E. Forms;E. Forms' },
    ]
  },
  {
    label: 'F. Evidence of foreign residence',
    code: 'E2FEOFR',
    items: [
      { label: 'F. Evidence of foreign residence', value: 'F. Evidence of foreign residence;F. Evidence of foreign residence' },
    ]
  }, 
  {
    label: 'G. Declaration of Intent to Depart the U.S',
    code: 'E2GDOITDTUS',
    items: [
      { label: 'G. Declaration of Intent to Depart the U.S', value: 'G. Declaration of Intent to Depart the U.S;G. Declaration of Intent to Depart the U.S' },
    ]
  },  
  {
    label: 'H. Source of Funds',
    code: 'E2HOD',
    items: [
      { label: 'Evidence of SOF', value: 'Evidence of SOF;H. Source of Funds' },
      { label: 'Movement of Funds to the US', value: 'Movement of Funds to the US;H. Source of Funds' },
    ]
  },
  {
    label: 'I. Ownership documents',
    code: 'E2IOD',
    items: [
      { label: 'Articles of Incorporation or Organization', value: 'Articles of Incorporation or Organization;I. Ownership documents' },
      { label: 'Bylaws or Operating Agreement', value: 'Bylaws or Operating Agreement;I. Ownership documents' },
      { label: 'EIN-Tax ID', value: 'EIN-Tax ID;I. Ownership documents' },
      { label: 'Marketing material', value: 'Marketing material;I. Ownership documents' },
      { label: 'Membership or Share Certificate', value: 'Membership or Share Certificate;I. Ownership documents' },
      { label: 'Organizational Chart', value: 'Organizational Chart;I. Ownership documents' },
      { label: 'Other documents', value: 'Other documents;I. Ownership documents' },
      { label: 'Photos of the business', value: 'Photos of the business;I. Ownership documents' },
    ]
  },
  {
    label: 'J. Investment of Funds (Wire transfers, purchase agreement, etc)',
    code: 'E2JIOFWTPA',
    items: [
      { label: 'Escrow agreement', value: 'Escrow agreement;J. Investment of Funds (Wire transfers, purchase agreement, etc)' },
      { label: 'Other documents', value: 'Other documents;J. Investment of Funds (Wire transfers, purchase agreement, etc)' },
      { label: 'Purchase - Franchise agreements', value: 'Purchase - Franchise agreements;J. Investment of Funds (Wire transfers, purchase agreement, etc)' },
      { label: 'Sale of Assets - Bill of Sales', value: 'Sale of Assets - Bill of Sales;J. Investment of Funds (Wire transfers, purchase agreement, etc)' },
      { label: 'Wire transfers-payment evidence', value: 'Wire transfers-payment evidence;J. Investment of Funds (Wire transfers, purchase agreement, etc)' },
    ]
  },
  {
    label: 'K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)',
    code: 'E2KROLLBI',
    items: [
      { label: 'Bank Statements', value: 'Bank Statements;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Equipment-inventory purchase', value: 'Equipment-inventory purchase;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Invoices', value: 'Invoices;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Invoices, checks, bank and credit card statements', value: 'Invoices, checks, bank and credit card statements;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Lease', value: 'Lease;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Licenses', value: 'Licenses;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Marketing Strategies and Social Media', value: 'Marketing Strategies and Social Media;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
      { label: 'Other documents', value: 'Other documents;K. Real and Operating (Lease, Licenses, Bank Statements, Invoices, etc)' },
    ]
  },
  {
    label: 'L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)',
    code: 'E2LMBPBSPLTW',
    items: [
      { label: 'Balance Sheet', value: 'Balance Sheet;L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
      { label: 'Business Plan', value: 'Business Plan;L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
      { label: 'Other documents', value: 'Other documents;L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
      { label: 'Profit and Loss (P and L)', value: 'Profit and Loss (P and L);L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
      { label: 'US Corporate Tax Returns', value: 'US Corporate Tax Returns;L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
      { label: 'W-2 and 1099, Forms 941, Payroll Records', value: 'W-2 and 1099, Forms 941, Payroll Records;L. Marginality (Business Plan, Balance Sheet, P and L, Taxes, W-2, etc)' },
    ]
  },
  {
    label: 'M. Employee qualifications (degress, certificates)',
    code: 'E2MEQDC',
    items: [
      { label: 'Awards and recognitions', value: 'Awards and recognitions;M. Employee qualifications (degress, certificates)' },
      { label: 'Certificates', value: 'Certificates;M. Employee qualifications (degress, certificates)' },
      { label: 'Curriculum Vitae (CV)', value: 'Curriculum Vitae (CV);M. Employee qualifications (degress, certificates)' },
      { label: 'Diplomas', value: 'Diplomas;M. Employee qualifications (degress, certificates)' },
      { label: 'Licenses', value: 'Licenses;M. Employee qualifications (degress, certificates)' },
      { label: 'Other documents', value: 'Other documents;M. Employee qualifications (degress, certificates)' },
      { label: 'Publications', value: 'Publications;M. Employee qualifications (degress, certificates)' },
      { label: 'Work experience', value: 'Work experience;M. Employee qualifications (degress, certificates)' },
    ]
  },
  {
    label: 'N. Job offer letter for Essential Employee',
    code: 'E2NJOLFEE',
    items: [
      { label: 'N. Job offer letter for Essential Employee', value: 'N. Job offer letter for Essential Employee;N. Job offer letter for Essential Employee' },
    ]
  },
  {
    label: 'O. Photos',
    code: 'E2OP',
    items: [
      { label: 'O. Photos', value: 'O. Photos;O. Photos' },
    ]
  },
  {
    label: 'P. Consular Interview and documents',
    code: 'E2PCIAD',
    items: [
      { label: 'P. Consular Interview and documents', value: 'P. Consular Interview and documents;P. Consular Interview and documents' },
    ]
  },
  {
    label: "Q. RFE",
    code: "E2QRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;Q. RFE" },
      { label: "RFE Response", value: "RFE Response;Q. RFE" },
    ],
  },
  {
    label: "R. NOID",
    code: "E2RN",
    items: [
      { label: "NOID documents", value: "NOID documents;R. NOID" },
      { label: "NOID Response", value: "NOID Response;R. NOID" },
    ],
  },
  {
    label: 'S. Withdrawal',
    code: 'E2SW',
    items: [
      { label: 'S. Withdrawal', value: 'S. Withdrawal;S. Withdrawal' },
    ]
  },
  {
    label: 'T. Others',
    code: 'E2TO',
    items: [
      { label: 'T. Others', value: 'T. Others;T. Others' },
    ]
  },
];

export const E3 =  [
  {
    label: 'A. CH files and scans',
    code: 'E3ACHFAS',
    items: [
      { label: 'Filing Fee', value: 'Filing Fee;A. CH files and scans' },
      { label: 'From Onboarding', value: 'From Onboarding;A. CH files and scans' },
      { label: 'Notices from USCIS (Receipt, Approval, Denial)', value: 'Notices from USCIS (Receipt, Approval, Denial);A. CH files and scans' },
    ]
  },
  {
    label: 'B. Client uploaded files',
    code: 'E3BCUF',
    items: [
      { label: 'B. Client uploaded files', value: 'B. Client uploaded files;B. Client uploaded files' },
    ]
  },
  {
    label: 'C. Application package',
    code: 'E3CAP',
    items: [
      { label: 'C. Application package', value: 'C. Application package;C. Application package' },
    ]
  },
  {
    label: 'D. Biographic documents',
    code: 'E3DBD',
    items: [
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Change or extensions of status granted', value: 'Change or extensions of status granted;D. Biographic documents' },
      { label: 'I-94s', value: 'I-94s;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Passports', value: 'Passports;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
      { label: 'Visas', value: 'Visas;D. Biographic documents' },
    ]
  },
  {
    label: 'E. Forms',
    code: 'E3EF',
    items: [
      { label: 'E. Forms', value: 'E. Forms;E. Forms' },
    ]
  },
  {
    label: 'F. Employee qualifications (degress, certificates)',
    code: 'E3FQDC',
    items: [
      { label: 'Awards and recognitions', value: 'Awards and recognitions;F. Employee qualifications (degress, certificates)' },
      { label: 'Certificates', value: 'Certificates;F. Employee qualifications (degress, certificates)' },
      { label: 'Curriculum Vitae (CV)', value: 'Curriculum Vitae (CV);F. Employee qualifications (degress, certificates)' },
      { label: 'Diplomas', value: 'Diplomas;F. Employee qualifications (degress, certificates)' },
      { label: 'Licenses', value: 'Licenses;F. Employee qualifications (degress, certificates)' },
      { label: 'Other documents', value: 'Other documents;F. Employee qualifications (degress, certificates)' },
      { label: 'Publications', value: 'Publications;F. Employee qualifications (degress, certificates)' },
      { label: 'Work experience', value: 'Work experience;F. Employee qualifications (degress, certificates)' },
    ]
  }, 
  {
    label: 'G. Job offer letter for Essential Employee',
    code: 'E3GJOLFEE',
    items: [
      { label: 'G. Job offer letter for Essential Employee', value: 'G. Job offer letter for Essential Employee;G. Job offer letter for Essential Employee' },
    ]
  },  
  {
    label: 'H. Photos',
    code: 'E2HOD',
    items: [
      { label: 'H. Photos', value: 'H. Photos;H. Photos' },
    ]
  },
  {
    label: 'I. Consular Interview and documents',
    code: 'E3ICIAD',
    items: [
      { label: 'I. Consular Interview and documents', value: 'I. Consular Interview and documents;I. Consular Interview and documents' },
    ]
  },
  {
    label: "J. RFE",
    code: "E3JRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;J. RFE" },
      { label: "RFE Response", value: "RFE Response;J. RFE" },
    ],
  },
  {
    label: "K. NOID",
    code: "E3KNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;K. NOID" },
      { label: "NOID Response", value: "NOID Response;K. NOID" },
    ],
  },
  {
    label: 'L. Withdrawal',
    code: 'E3LW',
    items: [
      { label: 'L. Withdrawal', value: 'L. Withdrawal;L. Withdrawal' },
    ]
  },
  {
    label: 'M. Others',
    code: 'E3MO',
    items: [
      { label: 'M. Others', value: 'M. Others;M. Others' },
    ]
  },
];

export const EB1 = [
  {
    label: "1. CH files (from Onboarding)",
    code: "EB1CH",
    items: [
      {
        label: "Filing Fee",
        value: "Filing Fee;1. CH files (from Onboarding)",
      },
      {
        label: "From Onboarding",
        value: "From Onboarding1. CH files (from Onboarding)",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);1. CH files (from Onboarding)",
      },
    ],
  },
  {
    label: "2. Translations",
    code: "EB1TR",
    items: [{ label: "1st Batch", value: "2nd Batch;2. Translations" }],
  },
  {
    label: "3. TOC and Binder",
    code: "EB1TOC",
    items: [
      {
        label: "3. TOC and Binder",
        value: "3. TOC and Binder;3. TOC and Binder",
      },
    ],
  },
  {
    label: "A. Forms",
    code: "EB1FORMS",
    items: [{ label: "A. Forms", value: "A. Forms;A. Forms" }],
  },
  {
    label: "B. Civil documents",
    code: "EB1CIVIL",
    items: [
      {
        label: "Passports, visas and I-94s",
        value:
          "Passports, visas and I-94s;B. Civil documents;B. Civil documents",
      },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;B. Civil documents",
      },
      {
        label: "Birth Certificates",
        value: "Birth Certificates;B. Civil documents",
      },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;B. Civil documents",
      },
    ],
  },
  {
    label: "C. Advanced degree (diplomas, academic evaluation)",
    code: "EB1AD",
    items: [
      {
        label: "Academic evaluation",
        value:
          "Academic evaluation;C. Advanced degree (diplomas, academic evaluation)",
      },
      {
        label: "Masters degree",
        value:
          "Masters degree;C. Advanced degree (diplomas, academic evaluation)",
      },
      {
        label: "Bacherlors degree",
        value:
          "Bacherlors degree;C. Advanced degree (diplomas, academic evaluation)",
      },
    ],
  },
  {
    label: "D. CV",
    code: "EB1CV",
    items: [
      {
        label: "Endeavor Statement (ES)",
        value: "Endeavor Statement (ES);D. CV",
      },
      {
        label: "Model-Plan for future activities",
        value: "Model-Plan for future activities;D. CV",
      },
    ],
  },
  {
    label: "E. Work Experience Letters",
    code: "EB1WORK",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);E. Work Experience Letters",
      },
      {
        label: "Foreign Companies",
        value: "Foreign Companies;E. Work Experience Letters",
      },
      {
        label: "Sample of Work Product",
        value: "Sample of Work Product;E. Work Experience Letters",
      },
      {
        label: "Work Experience letter (WELs)",
        value: "Work Experience letter (WELs);E. Work Experience Letters",
      },
    ],
  },
  {
    label: "F. Prizes or Awards",
    code: "EB1PRIZE",
    items: [
      { label: "Drafts", value: "Drafts" },
      {
        label: "Final version - approved",
        value: "Final version - approved;F. Prizes or Awards",
      },
      { label: "Questionnaires", value: "Questionnaires;F. Prizes or Awards" },
      {
        label: "Recommenders CV or Linkedin",
        value: "Recommenders CV or Linkedin;F. Prizes or Awards",
      },
    ],
  },
  {
    label: "G. Memberships",
    code: "EB1MEM",
    items: [
      { label: "Drafts", value: "Drafts;G. Memberships" },
      {
        label: "Final version - approved",
        value: "Final version - approved:;G. Memberships",
      },
      { label: "Questionnaires", value: "Questionnaires;G. Memberships" },
    ],
  },
  {
    label: "H. Published Material and Citations",
    code: "EB1PUB",
    items: [
      {
        label: "Certificates",
        value: "Certificates;H. Published Material and Citations",
      },
      {
        label: "Licenses",
        value: "Licenses;H. Published Material and Citations",
      },
      {
        label: "Memberships",
        value: "Memberships;H. Published Material and Citations",
      },
      {
        label: "Publications and Patents",
        value: "Publications and Patents;H. Published Material and Citations",
      },
      {
        label: "Awards and recognitions",
        value: "Awards and recognitions;H. Published Material and Citations",
      },
      {
        label: "Continuing education",
        value: "Continuing education;H. Published Material and Citations",
      },
      {
        label: "Media reports",
        value: "Media reports;H. Published Material and Citations",
      },
      { label: "Other", value: "Other;H. Published Material and Citations" },
    ],
  },
  {
    label: "I. Media Publications about the Applicant",
    code: "EB1MEDIA",
    items: [
      {
        label: "1.Substantial Merit",
        value: "1.Substantial Merit;I. Media Publications about the Applicant",
      },
      {
        label: "2.National Importance",
        value:
          "2.National Importance;I. Media Publications about the Applicant",
      },
      {
        label: "3. On Balance Prong 3",
        value:
          "3. On Balance Prong 3;I. Media Publications about the Applicant",
      },
      {
        label: "4. Brief",
        value: "4. Brief;I. Media Publications about the Applicant",
      },
    ],
  },
  {
    label: "J. Invited talks, review, and judge of others",
    code: "EB1INVITE",
    items: [
      {
        label: "J. Invited talks, review, and judge of others",
        value:
          "J. Invited talks, review, and judge of others;J. Invited talks, review, and judge of others",
      },
    ],
  },
  {
    label: "K. Major contributions to the field",
    code: "EB1MAJOR",
    items: [
      {
        label: "K. Major contributions to the field",
        value:
          "K. Major contributions to the field;K. Major contributions to the field",
      },
    ],
  },
  {
    label: "L. Artistic Exhibitions or Showcases",
    code: "EB1ART",
    items: [
      {
        label: "L. Artistic Exhibitions or Showcases",
        value:
          "L. Artistic Exhibitions or Showcases;L. Artistic Exhibitions or Showcases",
      },
    ],
  },
  {
    label: "M. Leading or Critical Role",
    code: "EB1LEAD",
    items: [
      {
        label: "M. Leading or Critical Role",
        value: "M. Leading or Critical Role;M. Leading or Critical Role",
      },
    ],
  },
  {
    label: "N. High Salary",
    code: "EB1HIGH",
    items: [
      { label: "N. High Salary", value: "N. High Salary;N. High Salary" },
    ],
  },
  {
    label: "O. Commercial Successes in the Performing Arts",
    code: "EB1COMM",
    items: [
      {
        label: "O. Commercial Successes in the Performing Arts",
        value:
          "O. Commercial Successes in the Performing Arts;O. Commercial Successes in the Performing Arts",
      },
    ],
  },
  {
    label: "P. Job Offer in the U.S. (for EB-1B)",
    code: "EB1JOB",
    items: [
      {
        label: "P. Job Offer in the U.S. (for EB-1B)",
        value:
          "P. Job Offer in the U.S. (for EB-1B);P. Job Offer in the U.S. (for EB-1B)",
      },
    ],
  },
  {
    label: "Q. Filing fee",
    code: "EB1FILING",
    items: [{ label: "Q. Filing fee", value: "Q. Filing fee;Q. Filing fee" }],
  },
  {
    label: "R. Checklist for Paralegals",
    code: "EB1CHECK",
    items: [
      {
        label: "R. Checklist for Paralegals",
        value: "R. Checklist for Paralegals;R. Checklist for Paralegals",
      },
    ],
  },
  {
    label: "S. Notices from USCIS (Receipt, Approval, RFE, Denial)",
    code: "EB1NOT",
    items: [
      {
        label: "S. Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "S. Notices from USCIS (Receipt, Approval, RFE, Denial);S. Notices from USCIS (Receipt, Approval, RFE, Denial)",
      },
    ],
  },
  {
    label: "T. Others",
    code: "EB1OTH",
    items: [{ label: "T. Others", value: "T. Others;T. Others" }],
  },
  {
    label: "Client Uploaded Documents",
    code: "CUD",
    items: [
      {
        label: "Client Uploaded Documents",
        value: "Client Uploaded Documents;Client Uploaded Documents",
      },
    ],
  },
];

export const EB1A = [
  {
    label: "A. CH files and scans",
    code: "EB1AACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB1ABCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB1ABCUF",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB1ADT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB1AEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB1AFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials and CV",
    code: "EB1AGACCV",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials and CV",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials and CV",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials and CV",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials and CV",
      },
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);G. Academic credentials and CV",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials and CV",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials and CV",
      },
    ],
  },
  {
    label: "H. Extraordinary Ability",
    code: "EB1AEXTRA",
    items: [
      {
        label: "Artistic Exhibitions or Showcases",
        value: "Artistic Exhibitions or Showcases;H. Extraordinary Ability",
      },
      {
        label: "Commercial Successes in the Performing Arts",
        value:
          "Commercial Successes in the Performing Arts;H. Extraordinary Ability",
      },
      {
        label: "High Remuneration",
        value: "High Remuneration;H. Extraordinary Ability",
      },
      {
        label: "Invited Talks, Review, and Judging Record",
        value:
          "Invited Talks, Review, and Judging Record;H. Extraordinary Ability",
      },
      {
        label: "Major Contribution to the Field",
        value: "Major Contribution to the Field;H. Extraordinary Ability",
      },
      {
        label: "Media and Publication Recognition",
        value: "Media and Publication Recognition;H. Extraordinary Ability",
      },
      { label: "Memberships", value: "Memberships;H. Extraordinary Ability" },
      {
        label: "Other documents",
        value: "Other documents;H. Extraordinary Ability",
      },
      {
        label: "Performance in a Leading or Major Role",
        value:
          "Performance in a Leading or Major Role;H. Extraordinary Ability",
      },
      {
        label: "Prizes or Awards",
        value: "Prizes or Awards;H. Extraordinary Ability",
      },
      {
        label: "Published Material and Citations",
        value: "Published Material and Citations;H. Extraordinary Ability",
      },
    ],
  },
  {
    label: "I. Writers",
    code: "EB1AWRIT",
    items: [{ label: "I. Writers", value: "I. Writers;I. Writers" }],
  },
  {
    label: "J. RFE",
    code: "EB1AJRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;J. RFE" },
      { label: "RFE Response", value: "RFE Response;J. RFE" },
    ],
  },
  {
    label: "K. NOID",
    code: "EB1AKNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;K. NOID" },
      { label: "NOID Response", value: "NOID Response;K. NOID" },
    ],
  },
  {
    label: "L. Withdrawal",
    code: "EB1ALW",
    items: [{ label: "L. Withdrawal", value: "L. Withdrawal;L. Withdrawal" }],
  },
  {
    label: "M. Others",
    code: "EB1AMO",
    items: [{ label: "M. Others", value: "M. Others;M. Others" }],
  },
];

export const EB1B = [
  {
    label: "A. CH files and scans",
    code: "EB1BACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB1BBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB1BBCUF",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB1BDT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB1BEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB1BFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials and CV",
    code: "EB1BGACCV",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials and CV",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials and CV",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials and CV",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials and CV",
      },
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);G. Academic credentials and CV",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials and CV",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials and CV",
      },
    ],
  },
  {
    label: "H. Job Offer in the U.S",
    code: "EB1BBCUF",
    items: [
      {
        label: "H. Job Offer in the U.S",
        value: "H. Job Offer in the U.S;H. Job Offer in the U.S",
      },
    ],
  },
  {
    label: "I. Outstanding-Academic Research (for EB-1B)",
    code: "EB1BEXTRA",
    items: [
      {
        label: "Invited Talks, Review, and Judging Record",
        value:
          "Invited Talks, Review, and Judging Record;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Major Contribution to the Field",
        value:
          "Major Contribution to the Field;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Media and Publication Recognition",
        value:
          "Media and Publication Recognition;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Memberships",
        value: "Memberships;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Other documents",
        value: "Other documents;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Prizes or Awards",
        value: "Prizes or Awards;I. Outstanding-Academic Research (for EB-1B)",
      },
      {
        label: "Published Material and Citations",
        value:
          "Published Material and Citations;I. Outstanding-Academic Research (for EB-1B)",
      },
    ],
  },
  {
    label: "J. Writers",
    code: "EB1AWRIT",
    items: [{ label: "J. Writers", value: "J. Writers;J. Writers" }],
  },
  {
    label: "K. RFE",
    code: "EB1BJRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;K. RFE" },
      { label: "RFE Response", value: "RFE Response;K. RFE" },
    ],
  },
  {
    label: "L. NOID",
    code: "EB1BKNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;L. NOID" },
      { label: "NOID Response", value: "NOID Response;L. NOID" },
    ],
  },
  {
    label: "M. Withdrawal",
    code: "EB1BLW",
    items: [{ label: "M. Withdrawal", value: "M. Withdrawal;M. Withdrawal" }],
  },
  {
    label: "N. Others",
    code: "EB1BMO",
    items: [{ label: "N. Others", value: "N. Others;N. Others" }],
  },
];

export const EB1C = [
  {
    label: "A. CH files and scans",
    code: "EB1CACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB1CBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB1CBCUF",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB1CDT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB1CEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB1CFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials and CV",
    code: "EB1CGACCV",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials and CV",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials and CV",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials and CV",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials and CV",
      },
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);G. Academic credentials and CV",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials and CV",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials and CV",
      },
    ],
  },
  {
    label: "H. Multinational executive or managerial evidence",
    code: "EB1CHMEOME",
    items: [
      {
        label: "H. Multinational executive or managerial evidence",
        value: "H. Multinational executive or managerial evidence;H. Multinational executive or managerial evidence",
      },
    ],
  },
  {
    label: "I. Job Offer in the U.S",
    code: "EB1CEXTRA",
    items: [
      {
        label: "I. Job Offer in the U.S",
        value:
          "I. Job Offer in the U.S;I. Job Offer in the U.S",
      },
   
    ],
  },
  {
    label: "J. US Company",
    code: "EB1CJUSC",
    items: [
      { label: "Articles of Incorporation or Organization", value: "Articles of Incorporation or Organization;J. US Company" },
      { label: "Balance Sheet", value: "Balance Sheet;J. US Company" },
      { label: "Bank statements", value: "Bank statements;J. US Company" },
      { label: "Business License", value: "Business License;J. US Company" },
      { label: "Business Plan", value: "Business Plan;J. US Company" },
      { label: "Business transactions (contracts, bills, etc)", value: "Business transactions (contracts, bills, etc);J. US Company" },
      { label: "Bylaws or Operating Agreement", value: "Bylaws or Operating Agreement;J. US Company" },
      { label: "Companys decision to transfer", value: "Companys decision to transfer;J. US Company" },
      { label: "EIN-Tax ID", value: "EIN-Tax ID;J. US Company" },
      { label: "Lease for business commercial space", value: "Lease for business commercial space;J. US Company" },
      { label: "Marketing material", value: "Marketing material;J. US Company" },
      { label: "Membership or Share Certificate", value: "Membership or Share Certificate;J. US Company" },
      { label: "Organizational Chart", value: "Organizational Chart;J. US Company" },
      { label: "Other documents", value: "Other documents;J. US Company" },
      { label: "Photos of the business", value: "Photos of the business;J. US Company" },
      { label: "Profit and Loss (P and L)", value: "Profit and Loss (P and L);J. US Company" },
      { label: "Relationship between foreign and US entity", value: "Relationship between foreign and US entity;J. US Company" },
      { label: "US Corporate Tax Returns", value: "US Corporate Tax Returns;J. US Company" },
      { label: "W-2 and 1099, Forms 941, Payroll Records", value: "W-2 and 1099, Forms 941, Payroll Records;J. US Company" },
    ],
  },
  {
    label: "K. Foreign Company",
    code: "EB1CJUSC",
    items: [
      { label: "Articles of Incorporation or Organization", value: "Articles of Incorporation or Organization;K. Foreign Company" },
      { label: "Balance Sheet", value: "Balance Sheet;K. Foreign Company" },
      { label: "Bank statements", value: "Bank statements;K. Foreign Company" },
      { label: "Business License", value: "Business License;K. Foreign Company" },
      { label: "Business transactions (contracts, bills, etc)", value: "Business transactions (contracts, bills, etc);K. Foreign Company" },
      { label: "Bylaws or Operating Agreement", value: "Bylaws or Operating Agreement;K. Foreign Company" },
      { label: "Corporate Tax or Annual Report", value: "Corporate Tax or Annual Report;K. Foreign Company" },
      { label: "Marketing material", value: "Marketing material;K. Foreign Company" },
      { label: "Membership or Share Certificate", value: "Membership or Share Certificate;K. Foreign Company" },
      { label: "Organizational Chart", value: "Organizational Chart;K. Foreign Company" },
      { label: "Other documents", value: "Other documents;K. Foreign Company" },
      { label: "Payroll Records", value: "Payroll Records;K. Foreign Company" },
      { label: "Photos of the business", value: "Photos of the business;K. Foreign Company" },
      { label: "Profit and Loss (P and L)", value: "Profit and Loss (P and L);K. Foreign Company" },
      { label: "Relationship between foreign and US entity", value: "Relationship between foreign and US entity;K. Foreign Company" },
    ],
  },
  {
    label: "L. Writers",
    code: "EB1CLW",
    items: [{ label: "L. Writers", value: "L. Writers;L. Writers" }],
  },
  {
    label: "M. RFE",
    code: "EB1CMRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;M. RFE" },
      { label: "RFE Response", value: "RFE Response;M. RFE" },
    ],
  },
  {
    label: "N. NOID",
    code: "EB1CNNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;N. NOID" },
      { label: "NOID Response", value: "NOID Response;N. NOID" },
    ],
  },
  {
    label: "O. Withdrawal",
    code: "EB1CMW",
    items: [{ label: "O. Withdrawal", value: "O. Withdrawal;O. Withdrawal" }],
  },
  {
    label: "P. Others",
    code: "EB1CNO",
    items: [{ label: "P. Others", value: "P. Others;P. Others" }],
  },
];

export const EB2 =  [
  {
    label: "A. CH files and scans",
    code: "EB2ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB2BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB2CTBAC",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB2DT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB2EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB2FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Curriculum Vitae (CV)",
    code: "EB2GCV",
    items: [
      {
        label: "G. Curriculum Vitae (CV)",
        value: "G. Curriculum Vitae (CV);G. Curriculum Vitae (CV)",
      },
    ],
  },
  {
    label: "H. Academic credentials",
    code: "EB2HAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;H. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;H. Academic credentials",
      },
      {
        label: "Certificates",
        value: "Certificates;H. Academic credentials",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;H. Academic credentials",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;H. Academic credentials",
      },
    
    ],
  },
  {
    label: "I. Exceptional Ability",
    code: "EB2IEA",
    items: [
      {
        label: "Awards and Recognitions",
        value: "Awards and Recognitions;I. Exceptional Ability",
      },
      {
        label: "Licenses",
        value:
          "Licenses;I. Exceptional Ability",
      },
      {
        label: "Memberships",
        value: "Memberships;I. Exceptional Ability",
      },
      {
        label: "Other documents",
        value:
          "Other documents;I. Exceptional Ability",
      },
      {
        label: "Salary or Other Remuneration",
        value: "Salary or Other Remuneration;I. Exceptional Ability",
      },
      {
        label: "Work Experience",
        value: "Work Experience;I. Exceptional Ability",
      },
    ],
  },
  {
    label: "J. Job Offer in the U.S",
    code: "EB2JJOITUS",
    items: [
      {
        label: "J. Job Offer in the U.S",
        value:
          "J. Job Offer in the U.S;J. Job Offer in the U.S",
      },
   
    ],
  },
  {
    label: "K. PERM Labor Certification",
    code: "EB2KPLC",
    items: [
      {
        label: "K. PERM Labor Certification",
        value:
          "K. PERM Labor Certification;K. PERM Labor Certification",
      },
   
    ],
  },
  {
    label: "L. Writers",
    code: "EB1CLW",
    items: [{ label: "L. Writers", value: "L. Writers;L. Writers" }],
  },
  {
    label: "M. RFE",
    code: "EB1CMRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;M. RFE" },
      { label: "RFE Response", value: "RFE Response;M. RFE" },
    ],
  },
  {
    label: "N. NOID",
    code: "EB1CNNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;N. NOID" },
      { label: "NOID Response", value: "NOID Response;N. NOID" },
    ],
  },
  {
    label: "O. Withdrawal",
    code: "EB1CMW",
    items: [{ label: "O. Withdrawal", value: "O. Withdrawal;O. Withdrawal" }],
  },
  {
    label: "P. Others",
    code: "EB1CNO",
    items: [{ label: "P. Others", value: "P. Others;P. Others" }],
  },
];

export const EB2_NIW_FOLDERS =   [
  {
    label: "A. CH files and scans",
    code: "EB2ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB2BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB2CTBAC",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB2DT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB2EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB2FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials",
    code: "EB2HAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials",
      },
      {
        label: "Masters degree",
        value: "Masters degree;G. Academic credentials",
      },
    
    ],
  },
  {
    label: "H. Endeavor Statement and Model - Plan",
    code: "EB2HAC",
    items: [
      {
        label: "Endeavor Statement (Drafts)",
        value: "Endeavor Statement (Drafts);H. Endeavor Statement and Model - Plan",
      },
      {
        label: "Endeavor Statement (Final version - approved)",
        value: "Endeavor Statement (Final version - approved);H. Endeavor Statement and Model - Plan",
      },
      {
        label: "Model-Plan (Drafts)",
        value: "Model-Plan (Drafts);H. Endeavor Statement and Model - Plan",
      },
      {
        label: "Model-Plan (Final version - approved)",
        value: "Model-Plan (Final version - approved);H. Endeavor Statement and Model - Plan",
      },
    ],
  },
  {
    label: "I. Work Experience",
    code: "EB2IWE",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);I. Work Experience",
      },
      {
        label: "Foreign Companies",
        value: "Foreign Companies;I. Work Experience",
      },
      {
        label: "Other documents",
        value: "Other documents;I. Work Experience",
      },
      {
        label: "Sample of Work Product",
        value: "Sample of Work Product;I. Work Experience",
      },
      {
        label: "Work Experience letter (WELs)",
        value: "Work Experience letter (WELs);I. Work Experience",
      },
    ],
  },
  {
    label: "J. Letters of Recommendation",
    code: "EB2JLOR",
    items: [
      {
        label: "Drafts",
        value: "Drafts;J. Letters of Recommendation",
      },
      {
        label: "Final version - approved",
        value: "Final version - approved;J. Letters of Recommendation",
      },
      {
        label: "Questionnaires",
        value: "Questionnaires;J. Letters of Recommendation",
      },
      {
        label: "Recommenders CV or Linkedin",
        value: "Recommenders CV or Linkedin;J. Letters of Recommendation",
      },
    ],
  },
  {
    label: "K. Letters of Interest",
    code: "EB2JLOR",
    items: [
      {
        label: "Drafts",
        value: "Drafts;K. Letters of Interest",
      },
      {
        label: "Final version - approved",
        value: "Final version - approved;K. Letters of Interest",
      },
      {
        label: "Questionnaires",
        value: "Questionnaires;K. Letters of Interest",
      },
    ],
  },
  {
    label: "L. Well- Positioned",
    code: "EB2JLWP",
    items: [
      {
        label: "Awards and Recognitions",
        value: "Awards and Recognitions;L. Well- Positioned",
      },
      {
        label: "Certificates",
        value: "Certificates;L. Well- Positioned",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;L. Well- Positioned",
      },
      {
        label: "Licenses",
        value: "Licenses;L. Well- Positioned",
      },
      {
        label: "Media Reports",
        value: "Media Reports;L. Well- Positioned",
      },
      {
        label: "Memberships",
        value: "Memberships;L. Well- Positioned",
      },
      {
        label: "Other documents",
        value: "Other documents;L. Well- Positioned",
      },
      {
        label: "Patents",
        value: "Patents;L. Well- Positioned",
      },
      {
        label: "Publications",
        value: "Publications;L. Well- Positioned",
      },
    ],
  },
  {
    label: "M. Writers",
    code: "EB1CLW",
    items: [{ label: "M. Writers", value: "M. Writers;M. Writers" }],
  },
  {
    label: "N. RFE",
    code: "EB1CMRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;N. RFE" },
      { label: "RFE Response", value: "RFE Response;N. RFE" },
    ],
  },
  {
    label: "O. NOID",
    code: "EB1CNNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;O. NOID" },
      { label: "NOID Response", value: "NOID Response;O. NOID" },
    ],
  },
  {
    label: "P. Withdrawal",
    code: "EB1CMW",
    items: [{ label: "P. Withdrawal", value: "P. Withdrawal;P. Withdrawal" }],
  },
  {
    label: "Q. Others",
    code: "EB1CNO",
    items: [{ label: "Q. Others", value: "Q. Others;Q. Others" }],
  },
];

export const EB3 =  [
  {
    label: "A. CH files and scans",
    code: "EB3ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB3BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "EB3CTBAC",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB3DT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB3EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB3FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials",
    code: "EB2HAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials",
      },
    
    ],
  },
  {
    label: "H. Beneficiary qualifications",
    code: "EB3IEA",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);H. Beneficiary qualifications",
      },
      {
        label: "Licenses",
        value:
          "Licenses;H. Beneficiary qualifications",
      },
      {
        label: "Memberships",
        value: "Memberships;H. Beneficiary qualifications",
      },
      {
        label: "Other documents",
        value:
          "Other documents;H. Beneficiary qualifications",
      },
      {
        label: "Work Experience",
        value: "Work Experience;H. Beneficiary qualifications",
      },
    ],
  },
  {
    label: "I. Job Offer in the U.S",
    code: "EB3IJOITUS",
    items: [
      {
        label: "I. Job Offer in the U.S",
        value:
          "I. Job Offer in the U.S;I. Job Offer in the U.S",
      },
   
    ],
  },
  {
    label: "J. PERM Labor Certification",
    code: "EB3jPLC",
    items: [
      {
        label: "J. PERM Labor Certification",
        value:
          "J. PERM Labor Certification;J. PERM Labor Certification",
      },
   
    ],
  },
  {
    label: "K. Writers",
    code: "EB3KW",
    items: [{ label: "K. Writers", value: "K. Writers;K. Writers" }],
  },
  {
    label: "L. RFE",
    code: "EB3LRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;L. RFE" },
      { label: "RFE Response", value: "RFE Response;L. RFE" },
    ],
  },
  {
    label: "M. NOID",
    code: "EB3MNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;M. NOID" },
      { label: "NOID Response", value: "NOID Response;M. NOID" },
    ],
  },
  {
    label: "N. Withdrawal",
    code: "EB3NW",
    items: [{ label: "N. Withdrawal", value: "N. Withdrawal;N. Withdrawal" }],
  },
  {
    label: "O. Others",
    code: "EB3Oo",
    items: [{ label: "O. Others", value: "O. Others;O. Others" }],
  },
];

export const EB5 =  [
  {
    label: "A. CH files and scans",
    code: "EB5ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "EB5BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "EB5CAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "EB3DT",
    items: [
      { label: "D. Translations", value: "D. Translations;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "EB3EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "EB3FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials and CV",
    code: "EB5GACACV",
    items: [
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials and CV",
      },
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);G. Academic credentials and CV",
      },
      {
        label: "Diplomas",
        value: "Diplomas;G. Academic credentials and CV",
      },
      
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials and CV",
      },
    ],
  },
  {
    label: "H. Taxes (most recent 5 years)",
    code: "EB5HTAXES",
    items: [{ label: "H. Taxes (most recent 5 years)", value: "H. Taxes (most recent 5 years);H. Taxes (most recent 5 years)" }],
  },
  {
    label: "I. Statement of the Origin of Funds",
    code: "EB5ISTATEMENT",
    items: [{ label: "I. Statement of the Origin of Funds", value: "I. Statement of the Origin of Funds;I. Statement of the Origin of Funds" }],
  },
  {
    label: "J. Capital earned through ownership of business",
    code: "EB5JCAPITAL",
    items: [
      {
        label: "Business premises and printed material",
        value: "Business premises and printed material;J. Capital earned through ownership of business",
      },
      {
        label: "Business registration",
        value:
          "Business registration;J. Capital earned through ownership of business",
      },
      {
        label: "Business taxes (last 5 years)",
        value: "Business taxes (last 5 years);J. Capital earned through ownership of business",
      },
      {
        label: "Company license",
        value:
          "Company license;J. Capital earned through ownership of business",
      },
      {
        label: "Distribution of dividends",
        value: "Distribution of dividends;J. Capital earned through ownership of business",
      },
      {
        label: "Financial statements",
        value: "Financial statements;J. Capital earned through ownership of business",
      },
      {
        label: "Other documents",
        value: "Other documents;J. Capital earned through ownership of business",
      },
      {
        label: "Partnership agreement, share register",
        value: "Partnership agreement, share register;J. Capital earned through ownership of business",
      },
      {
        label: "SOF to purchase shares",
        value: "SOF to purchase shares;J. Capital earned through ownership of business",
      },
    ],
  },
  {
    label: "K. Capital earned through property sale",
    code: "EB5JCAPITAL",
    items: [
      {
        label: "Loan and mortgage documents",
        value: "Loan and mortgage documents;K. Capital earned through property sale",
      },
      {
        label: "Other documents",
        value:
          "Other documents;K. Capital earned through property sale",
      },
      {
        label: "Payment of purchase price",
        value: "Payment of purchase price;K. Capital earned through property sale",
      },
      {
        label: "Property ownership registration",
        value:
          "Property ownership registration;K. Capital earned through property sale",
      },
      {
        label: "Property purchase contract",
        value: "Property purchase contract;K. Capital earned through property sale",
      },
      {
        label: "Property sales contract",
        value: "Property sales contract;K. Capital earned through property sale",
      },
      {
        label: "Real estate tax certificate",
        value: "Real estate tax certificate;K. Capital earned through property sale",
      },
      {
        label: "Receipt of purchase price",
        value: "Receipt of purchase price;K. Capital earned through property sale",
      },
      {
        label: "SOF to purchase the propery",
        value: "SOF to purchase the propery;K. Capital earned through property sale",
      },
    ],
  },
  {
    label: "L. Capital earned through gift",
    code: "EB5JCAPITAL",
    items: [
      {
        label: "Donor-donee relationship",
        value: "Donor-donee relationship;L. Capital earned through gift",
      },
      {
        label: "Donor education and job background",
        value:
          "Donor education and job background;L. Capital earned through gift",
      },
      {
        label: "Donors Civil Documents",
        value: "Donors Civil Documents;L. Capital earned through gift",
      },
      {
        label: "Donor statement of gift",
        value:
          "Donor statement of gift;L. Capital earned through gift",
      },
      {
        label: "Donor taxes (last 5 years)",
        value: "Donor taxes (last 5 years);L. Capital earned through gift",
      },
      {
        label: "Other documents",
        value: "Other documents;L. Capital earned through gift",
      },
      {
        label: "Payment of gift taxes",
        value: "Payment of gift taxes;L. Capital earned through gift",
      },
      {
        label: "SOF to gift amount",
        value: "SOF to gift amount;L. Capital earned through gift",
      },
      {
        label: "Transfer of funds donor-donee",
        value: "Transfer of funds donor-donee;L. Capital earned through gift",
      },
    ],
  },
  {
    label: "M. Capital earned through loan",
    code: "EB5MCAPITAL",
    items: [
      {
        label: "Loan agreement",
        value: "Loan agreement;M. Capital earned through loan",
      },
      {
        label: "Other documents",
        value:
          "Other documents;M. Capital earned through loan",
      },
      {
        label: "Receipt of loan capital",
        value: "Receipt of loan capital;M. Capital earned through loan",
      },
     
     
    ],
  },
  {
    label: "N. Capital earned through employment earnings",
    code: "EB5NCAPITAL",
    items: [
      {
        label: "Bank statements of savings",
        value: "Bank statements of savings;N. Capital earned through employment earnings",
      },
      {
        label: "Employer evidence",
        value:
          "Employer evidence;N. Capital earned through employment earnings",
      },
      {
        label: "Employment evidence",
        value: "Employment evidence;N. Capital earned through employment earnings",
      },
      {
        label: "Other documents",
        value: "Other documents;N. Capital earned through employment earnings",
      },
      {
        label: "Payroll records",
        value: "Payroll records;N. Capital earned through employment earnings",
      },
    ],
  },
  {
    label: "O. Capital earned through inheritance",
    code: "EB5NCAPITAL",
    items: [
      {
        label: "Benefactor - Beneficiray relationship",
        value: "Benefactor - Beneficiray relationship;O. Capital earned through inheritance",
      },
      {
        label: "Inheritance tax payment",
        value:
          "Inheritance tax payment;O. Capital earned through inheritance",
      },
      {
        label: "Other documents",
        value: "Other documents;O. Capital earned through inheritance",
      },
      {
        label: "Other documents",
        value: "Other documents;O. Capital earned through inheritance",
      },
      {
        label: "Receipt of inherited funds",
        value: "Receipt of inherited funds;O. Capital earned through inheritance",
      },
      {
        label: "SOF to acquired inherited funds",
        value: "SOF to acquired inherited funds;O. Capital earned through inheritance",
      },
      {
        label: "Will and testament",
        value: "Will and testament;O. Capital earned through inheritance",
      },
    ],
  },
  {
    label: "P. Other SOF",
    code: "EB5CAP",
    items: [
      {
        label: "P. Other SOF",
        value: "P. Other SOF;P. Other SOF",
      },
    ],
  },
  {
    label: "Q. Transfer of funds to the U.S. enterprise",
    code: "EB5QTRANSFER",
    items: [
      {
        label: "Bank statements showing capital",
        value: "Bank statements showing capital;Q. Transfer of funds to the U.S. enterprise",
      },
      {
        label: "Bank transfers, wire receipts to the US",
        value:
          "Bank transfers, wire receipts to the US;Q. Transfer of funds to the U.S. enterprise",
      },
      {
        label: "Other documents",
        value: "Other documents;Q. Transfer of funds to the U.S. enterprise",
      },
    ],
  },
  {
    label: "R. RFE",
    code: "EB5RRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;R. RFE" },
      { label: "RFE Response", value: "RFE Response;R. RFE" },
    ],
  },
  {
    label: "S. NOID",
    code: "EB5SNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;S. NOID" },
      { label: "NOID Response", value: "NOID Response;S. NOID" },
    ],
  },
  {
    label: "T. Withdrawal",
    code: "EB5TW",
    items: [{ label: "T. Withdrawal", value: "T. Withdrawal;T. Withdrawal" }],
  },
  {
    label: "U. Others",
    code: "EB5UO",
    items: [{ label: "U. Others", value: "U. Others;U. Others" }],
  },
];

export const H1B =  [
  {
    label: "A. CH files and scans",
    code: "H1BACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "H1BBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "H1BCTBAC",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "H1BDT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "H1BEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "H1BFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials",
    code: "H1BGAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials",
      },
    ],
  },
  {
    label: "H. Beneficiary qualifications",
    code: "H1BHBQ",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);H. Beneficiary qualifications",
      },
      {
        label: "Licenses",
        value:
          "Licenses;H. Beneficiary qualifications",
      },
      {
        label: "Memberships",
        value: "Memberships;H. Beneficiary qualifications",
      },
      {
        label: "Other documents",
        value:
          "Other documents;H. Beneficiary qualifications",
      },
      {
        label: "Pay Stubs",
        value: "Pay Stubs;H. Beneficiary qualifications",
      },
      {
        label: "Work Experience Letters (WELs)",
        value: "Work Experience Letters (WELs);H. Beneficiary qualifications",
      },
    ],
  },
  {
    label: "I. Job Offer in the U.S",
    code: "H1BIJOITUS",
    items: [
      {
        label: "I. Job Offer in the U.S",
        value:
          "I. Job Offer in the U.S;I. Job Offer in the U.S",
      },
   
    ],
  },
  {
    label: "J. US Company",
    code: "H1BHBQ",
    items: [
      {
        label: "Articles of Incorporation or Organization",
        value: "Articles of Incorporation or Organization;J. US Company",
      },
      {
        label: "Balance Sheet",
        value:
          "Balance Sheet;J. US Company",
      },
      {
        label: "Bank statements",
        value: "Bank statements;J. US Company",
      },
      {
        label: "Business License",
        value:
          "Business License;J. US Company",
      },
      {
        label: "Business Plan",
        value: "Business Plan;J. US Company",
      },
      {
        label: "Bylaws or Operating Agreement",
        value: "Bylaws or Operating Agreement;J. US Company",
      },
      {
        label: "EIN-Tax ID",
        value: "EIN-Tax ID;J. US Company",
      },
      {
        label: "Marketing material",
        value: "Marketing material;J. US Company",
      },
      {
        label: "Membership or Share Certificate",
        value: "Membership or Share Certificate;J. US Company",
      },

      {
        label: "Organizational Chart",
        value: "Organizational Chart;J. US Company",
      },
      {
        label: "Other documents",
        value: "Other documents;J. US Company",
      },
      {
        label: "Photos of the business",
        value: "Photos of the business;J. US Company",
      },
      {
        label: "Profit and Loss (P and L)",
        value: "Profit and Loss (P and L);J. US Company",
      },
      {
        label: "US Corporate Tax Returns",
        value: "US Corporate Tax Returns;J. US Company",
      },
      {
        label: "W-2 and 1099, Forms 941, Payroll Records",
        value: "W-2 and 1099, Forms 941, Payroll Records;J. US Company",
      },
    ],
  },
  {
    label: "K. Photos",
    code: "H1BKP",
    items: [{ label: "K. Photos", value: "K. Photos;K. Photos" }],
  },
  {
    label: "L. Consular interview and documents",
    code: "H1BLCIAD",
    items: [{ label: "L. Consular interview and documents", value: "L. Consular interview and documents;L. Consular interview and documents" }],
  },
  {
    label: "M. RFE",
    code: "H1BMRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;M. RFE" },
      { label: "RFE Response", value: "RFE Response;M. RFE" },
    ],
  },
  {
    label: "N. NOID",
    code: "H1BMNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;N. NOID" },
      { label: "NOID Response", value: "NOID Response;N. NOID" },
    ],
  },
  {
    label: "O. Withdrawal",
    code: "H1BNW",
    items: [{ label: "O. Withdrawal", value: "O. Withdrawal;O. Withdrawal" }],
  },
  {
    label: "P. Others",
    code: "H1BPO",
    items: [{ label: "P. Others", value: "P. Others;P. Others" }],
  },
];

export const I90 = [
  {
    label: "A. CH files and scans",
    code: "I90ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I90BBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I90CTBAC",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Biographic documents",
    code: "I90DBD",
    items: [
      { label: "Birth Certificates", value: "Birth Certificates;D. Biographic documents" },
      { label: "Government-issued ID", value: "Government-issued ID;D. Biographic documents" },
      { label: "Green Card", value: "Green Card;D. Biographic documents" },
      { label: "Marriage Certificate", value: "Marriage Certificate;D. Biographic documents" },
      { label: "Other documents", value: "Other documents;D. Biographic documents" },
      { label: "Passport, I-551 stamp", value: "Passport, I-551 stamp;D. Biographic documents" },
    ],
  },
  {
    label: "E. Forms",
    code: "I90EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Photos",
    code: "I90FP",
    items: [{ label: "F. Photos", value: "F. Photos;F. Photos" }],
  },
  {
    label: "G. Inquiries to USCIS",
    code: "I90GITU",
    items: [{ label: "G. Inquiries to USCIS", value: "G. Inquiries to USCIS;G. Inquiries to USCIS" }],
  },
  {
    label: "H. Inquiries to Ombudsman",
    code: "I90GITU",
    items: [{ label: "H. Inquiries to Ombudsman", value: "H. Inquiries to Ombudsman;H. Inquiries to Ombudsman" }],
  },
  {
    label: "I. Change of Address",
    code: "I90GITU",
    items: [{ label: "I. Change of Address", value: "I. Change of Address;I. Change of Address" }],
  },
  {
    label: "J. RFE",
    code: "I90RFE",
    items: [
      { label: "RFE documents", value: "RFE documents;J. RFE" },
      { label: "RFE Response", value: "RFE Response;J. RFE" },
    ],
  },
  {
    label: "K. NOID",
    code: "I90KNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;K. NOID" },
      { label: "NOID Response", value: "NOID Response;K. NOID" },
    ],
  },
  {
    label: "L. Withdrawal",
    code: "I90LW",
    items: [{ label: "L. Withdrawal", value: "L. Withdrawal;L. Withdrawal" }],
  },
  {
    label: "M. Others",
    code: "I90MO",
    items: [{ label: "M. Others", value: "M. Others;M. Others" }],
  },
];

export const I131 =  [
  {
    label: "A. CH files and scans",
    code: "I131ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I131BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I131CAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: 'D. Biographic documents',
    code: 'I131DBD',
    items: [
      { label: 'Arrest records', value: 'Arrest records;D. Biographic documents' },
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Green Cards', value: 'Green Cards;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Other documents', value: 'Other documents;D. Biographic documents' },
      { label: 'Passports, I-551 stamp', value: 'Passports, I-551 stamp;D. Biographic documents' },
      { label: 'Tax Returns', value: 'Tax Returns;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
    ]
  },
  {
    label: "E. Forms",
    code: "I131EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "I131FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Photos",
    code: "I131GP",
    items: [{ label: "G. Photos", value: "G. Photos;G. Photos" }],
  },
  {
    label: "H. Inquiries to USCIS",
    code: "I131HITU",
    items: [{ label: "H. Inquiries to USCIS", value: "H. Inquiries to USCIS;H. Inquiries to USCIS" }],
  },
  {
    label: "I. Inquiries to Ombudsman",
    code: "I131IITQ",
    items: [{ label: "I. Inquiries to Ombudsman", value: "I. Inquiries to Ombudsman;I. Inquiries to Ombudsman" }],
  },
  {
    label: "J. Change of Address",
    code: "I131JCOA",
    items: [{ label: "J. Change of Address", value: "J. Change of Address;J. Change of Address" }],
  },
  {
    label: "K. Documents received from USCIS",
    code: "I131KDRFU",
    items: [{ label: "K. Documents received from USCIS", value: "K. Documents received from USCIS;K. Documents received from USCIS" }],
  },
  {
    label: "L. RFE",
    code: "I131LRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;L. RFE" },
      { label: "RFE Response", value: "RFE Response;L. RFE" },
    ],
  },
  {
    label: "M. NOID",
    code: "I131MNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;M. NOID" },
      { label: "NOID Response", value: "NOID Response;M. NOID" },
    ],
  },
  {
    label: "N. Withdrawal",
    code: "I131NW",
    items: [{ label: "N. Withdrawal", value: "N. Withdrawal;N. Withdrawal" }],
  },
  {
    label: "O. Others",
    code: "I131OO",
    items: [{ label: "O. Others", value: "O. Others;O. Others" }],
  },
];

export const I290B = [
  {
    label: "A. CH files and scans",
    code: "I290ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I290BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I290CTBAC",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Brief package",
    code: "I290DBP",
    items: [
      {
        label: "D. Brief package",
        value: "D. Brief package;D. Brief package",
      },
    ],
  },
  {
    label: "E. Forms",
    code: "I290EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Inquiries to USCIS",
    code: "I290BFITU",
    items: [{ label: "F. Inquiries to USCIS", value: "F. Inquiries to USCIS;F. Inquiries to USCIS" }],
  },
  {
    label: "G. Inquiries to Ombudsman",
    code: "I290GITO",
    items: [{ label: "G. Inquiries to Ombudsman", value: "G. Inquiries to Ombudsman;G. Inquiries to Ombudsman" }],
  },
  {
    label: "H. Change of Address",
    code: "I290HCOA",
    items: [{ label: "H. Change of Address", value: "H. Change of Address;H. Change of Address" }],
  },
  {
    label: "I. RFE",
    code: "I290IRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;I. RFE" },
      { label: "RFE Response", value: "RFE Response;I. RFE" },
    ],
  },
  {
    label: "J. NOID",
    code: "I290JNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;J. NOID" },
      { label: "NOID Response", value: "NOID Response;J. NOID" },
    ],
  },
  {
    label: "K. Withdrawal",
    code: "I290KW",
    items: [{ label: "K. Withdrawal", value: "K. Withdrawal;K. Withdrawal" }],
  },
  {
    label: "L. Others",
    code: "I290LO",
    items: [{ label: "L. Others", value: "L. Others;L. Others" }],
  },
];

export const I765 =  [
  {
    label: "A. CH files and scans",
    code: "I765ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I765BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I765CAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: 'D. Biographic documents',
    code: 'I765DBD',
    items: [
      { label: 'Arrest records', value: 'Arrest records;D. Biographic documents' },
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Green Cards', value: 'Green Cards;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Other documents', value: 'Other documents;D. Biographic documents' },
      { label: 'Passports, I-551 stamp', value: 'Passports, I-551 stamp;D. Biographic documents' },
      { label: 'Tax Returns', value: 'Tax Returns;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
    ]
  },
  {
    label: "E. Forms",
    code: "I765EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "I765FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Photos",
    code: "I765GP",
    items: [{ label: "G. Photos", value: "G. Photos;G. Photos" }],
  },
  {
    label: "H. Inquiries to USCIS",
    code: "I765HITU",
    items: [{ label: "H. Inquiries to USCIS", value: "H. Inquiries to USCIS;H. Inquiries to USCIS" }],
  },
  {
    label: "I. Inquiries to Ombudsman",
    code: "I765ITTO",
    items: [{ label: "I. Inquiries to Ombudsman", value: "I. Inquiries to Ombudsman;I. Inquiries to Ombudsman" }],
  },
  {
    label: "J. Change of Address",
    code: "I765JCOA",
    items: [{ label: "J. Change of Address", value: "J. Change of Address;J. Change of Address" }],
  },
  {
    label: "K. Documents received from USCIS",
    code: "I765KDRFU",
    items: [{ label: "K. Documents received from USCIS", value: "K. Documents received from USCIS;K. Documents received from USCIS" }],
  },
  {
    label: "L. RFE",
    code: "I765LRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;L. RFE" },
      { label: "RFE Response", value: "RFE Response;L. RFE" },
    ],
  },
  {
    label: "M. NOID",
    code: "I765MNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;M. NOID" },
      { label: "NOID Response", value: "NOID Response;M. NOID" },
    ],
  },
  {
    label: "N. Withdrawal",
    code: "I765NW",
    items: [{ label: "N. Withdrawal", value: "N. Withdrawal;N. Withdrawal" }],
  },
  {
    label: "O. Others",
    code: "I765OO",
    items: [{ label: "O. Others", value: "O. Others;O. Others" }],
  },
];

export const I824 =   [
  {
    label: "A. CH files and scans",
    code: "I824ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I824BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I824CAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: 'D. Biographic documents',
    code: 'I824DBD',
    items: [
      { label: 'Arrest records', value: 'Arrest records;D. Biographic documents' },
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Green Cards', value: 'Green Cards;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Other documents', value: 'Other documents;D. Biographic documents' },
      { label: 'Passports, I-551 stamp', value: 'Passports, I-551 stamp;D. Biographic documents' },
      { label: 'Tax Returns', value: 'Tax Returns;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
    ]
  },
  {
    label: "E. Forms",
    code: "I824EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "I824FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      { label: "Main Applicants Green Card", value: "Main Applicants Green Card;F. Biographic documents" },
      { label: "Marriage Certificate", value: "Marriage Certificate;F. Biographic documents" },
      { label: "Passports, visas, I-94s", value: "Passports, visas, I-94s;F. Biographic documents" },
      { label: "Termination of Prior Marriages", value: "Termination of Prior Marriages;F. Biographic documents" },
    ],
  },
  {
    label: "G. Photos",
    code: "I824GP",
    items: [{ label: "G. Photos", value: "G. Photos;G. Photos" }],
  },
  {
    label: "H. Inquiries to USCIS",
    code: "I824HITU",
    items: [{ label: "H. Inquiries to USCIS", value: "H. Inquiries to USCIS;H. Inquiries to USCIS" }],
  },
  {
    label: "I. Inquiries to Ombudsman",
    code: "I824ITTO",
    items: [{ label: "I. Inquiries to Ombudsman", value: "I. Inquiries to Ombudsman;I. Inquiries to Ombudsman" }],
  },
  {
    label: "J. Change of Address",
    code: "I824JCOA",
    items: [{ label: "J. Change of Address", value: "J. Change of Address;J. Change of Address" }],
  },
  {
    label: "K. RFE",
    code: "I824KRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;K. RFE" },
      { label: "RFE Response", value: "RFE Response;K. RFE" },
    ],
  },
  {
    label: "L. NOID",
    code: "I824LNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;L. NOID" },
      { label: "NOID Response", value: "NOID Response;L. NOID" },
    ],
  },
  {
    label: "M. Withdrawal",
    code: "I824MW",
    items: [{ label: "M. Withdrawal", value: "M. Withdrawal;M. Withdrawal" }],
  },
  {
    label: "N. Others",
    code: "I824NO",
    items: [{ label: "N. Others", value: "N. Others;N. Others" }],
  },
];

export const I829 = [
  {
    label: "A. CH files and scans",
    code: "I829ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "I829BBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "I829CTBAC",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Biographic documents",
    code: "I829DBD",
    items: [
      { label: "Green Cards", value: "Green Cards;D. Biographic documents" },
      { label: "Termination of Prior Marriages", value: "Termination of Prior Marriages;D. Biographic documents" },
    ],
  },
  {
    label: "E. Forms",
    code: "I829EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Photos",
    code: "I829FP",
    items: [{ label: "F. Photos", value: "F. Photos;F. Photos" }],
  },
  {
    label: "G. Inquiries to USCIS",
    code: "I829GITU",
    items: [{ label: "G. Inquiries to USCIS", value: "G. Inquiries to USCIS;G. Inquiries to USCIS" }],
  },
  {
    label: "H. Inquiries to Ombudsman",
    code: "I829HITO",
    items: [{ label: "H. Inquiries to Ombudsman", value: "H. Inquiries to Ombudsman;H. Inquiries to Ombudsman" }],
  },
  {
    label: "I. Change of Address",
    code: "I829GITU",
    items: [{ label: "I. Change of Address", value: "I. Change of Address;I. Change of Address" }],
  },
  {
    label: "J. RFE",
    code: "I829RFE",
    items: [
      { label: "RFE documents", value: "RFE documents;J. RFE" },
      { label: "RFE Response", value: "RFE Response;J. RFE" },
    ],
  },
  {
    label: "K. NOID",
    code: "I829KNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;K. NOID" },
      { label: "NOID Response", value: "NOID Response;K. NOID" },
    ],
  },
  {
    label: "L. Withdrawal",
    code: "I829LW",
    items: [{ label: "L. Withdrawal", value: "L. Withdrawal;L. Withdrawal" }],
  },
  {
    label: "M. Others",
    code: "I829MO",
    items: [{ label: "M. Others", value: "M. Others;M. Others" }],
  },
];

export const L1 =   [
  {
    label: "A. CH files and scans",
    code: "L1ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "L1BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "L1CTBAC",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "L1DT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "L1EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "L1FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Change or extensions of status granted",
        value: "Change or extensions of status granted;F. Biographic documents",
      },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Academic credentials",
    code: "L1GAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials",
      },
    ],
  },
  {
    label: "H. Executive or managerial evidence",
    code: "L1HAC",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);H. Executive or managerial evidence",
      },
      {
        label: "Job description",
        value: "Job description;H. Executive or managerial evidence",
      },
      {
        label: "Other documents",
        value: "Other documents;H. Executive or managerial evidence",
      },
      {
        label: "Pay Stubs",
        value: "Pay Stubs;H. Executive or managerial evidence",
      },
      {
        label: "Personal Income Tax Return",
        value: "Personal Income Tax Return;H. Executive or managerial evidence",
      },
      {
        label: "Work Experience Letters (WELs)",
        value: "Work Experience Letters (WELs);H. Executive or managerial evidence",
      },
    ],
  },
  {
    label: "I. Job Offer in the U.S",
    code: "L1IJOITUS",
    items: [{ label: "I. Job Offer in the U.S", value: "I. Job Offer in the U.S;I. Job Offer in the U.S" }],
  },

  {
    label: "J. US Company",
    code: "L1JUC",
    items: [
      {
        label: "Articles of Incorporation or Organization",
        value: "Articles of Incorporation or Organization;J. US Company",
      },
      {
        label: "Balance Sheet",
        value: "Balance Sheet;J. US Company",
      },
      {
        label: "Bank statements",
        value: "Bank statements;J. US Company",
      },
      {
        label: "Business License",
        value: "Business License;J. US Company",
      },
      {
        label: "Business Plan",
        value: "Business Plan;J. US Company",
      },
      {
        label: "Business transactions (contracts, bills, etc)",
        value: "Business transactions (contracts, bills, etc);J. US Company",
      },
      {
        label: "Bylaws or Operating Agreement",
        value: "Bylaws or Operating Agreement;J. US Company",
      },
      {
        label: "EIN-Tax ID",
        value: "EIN-Tax ID;J. US Company",
      },
      {
        label: "Lease for business commercial space",
        value: "Lease for business commercial space;J. US Company",
      },
      {
        label: "Marketing material",
        value: "Marketing material;J. US Company",
      },
      {
        label: "Membership or Share Certificate",
        value: "Membership or Share Certificate;J. US Company",
      },
      {
        label: "Organizational Chart",
        value: "Organizational Chart;J. US Company",
      },
      {
        label: "Other documents",
        value: "Other documents;J. US Company",
      },
      {
        label: "Photos of the business",
        value: "Photos of the business;J. US Company",
      },
      {
        label: "Profit and Loss (P and L)",
        value: "Profit and Loss (P and L);J. US Company",
      },
      {
        label: "US Corporate Tax Returns",
        value: "US Corporate Tax Returns;J. US Company",
      },
      {
        label: "W-2 and 1099, Forms 941, Payroll Records",
        value: "W-2 and 1099, Forms 941, Payroll Records;J. US Company",
      },
    ],
  },
  {
    label: "K. Foreign Company",
    code: "L1KFC",
    items: [
      {
        label: "Articles of Incorporation or Organization",
        value: "Articles of Incorporation or Organization;K. Foreign Company",
      },
      {
        label: "Balance Sheet",
        value: "Balance Sheet;K. Foreign Company",
      },
      {
        label: "Bank statements",
        value: "Bank statements;K. Foreign Company",
      },
      {
        label: "Business License",
        value: "Business License;K. Foreign Company",
      },
      {
        label: "Business transactions (contracts, bills, etc)",
        value: "Business transactions (contracts, bills, etc);K. Foreign Company",
      },
      {
        label: "Bylaws or Operating Agreement",
        value: "Bylaws or Operating Agreement;K. Foreign Company",
      },
      {
        label: "Corporate Tax or Annual Report",
        value: "Corporate Tax or Annual Report;K. Foreign Company",
      },
      {
        label: "Marketing material",
        value: "Marketing material;K. Foreign Company",
      },
      {
        label: "Membership or Share Certificate",
        value: "Membership or Share Certificate;K. Foreign Company",
      },
      {
        label: "Organizational chart",
        value: "Organizational chart;K. Foreign Company",
      },
      {
        label: "Other documents",
        value: "Other documents;K. Foreign Company",
      },
      {
        label: "Payroll Records",
        value: "Payroll Records;K. Foreign Company",
      },
      {
        label: "Photos of the business",
        value: "Photos of the business;K. Foreign Company",
      },
      {
        label: "Profit and Loss (P and L)",
        value: "Profit and Loss (P and L);K. Foreign Company",
      },
      {
        label: "Relationship between foreign and US entity",
        value: "Relationship between foreign and US entity;K. Foreign Company",
      },
    ],
  },

  {
    label: "L. Consular interview and documents",
    code: "L1LCIAD",
    items: [{ label: "L. Consular interview and documents", value: "L. Consular interview and documents;L. Consular interview and documents" }],
  },
  {
    label: "L. Photos",
    code: "L1LP",
    items: [{ label: "L. Photos", value: "L. Photos;L. Photos" }],
  },
  {
    label: "M. Consular interview and documents",
    code: "L1MCIAD",
    items: [{ label: "M. Consular interview and documents", value: "M. Consular interview and documents;M. Consular interview and documents" }],
  },
  {
    label: "N. RFE",
    code: "L1NRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;N. RFE" },
      { label: "RFE Response", value: "RFE Response;N. RFE" },
    ],
  },
  {
    label: "O. NOID",
    code: "L1ONOID",
    items: [
      { label: "NOID documents", value: "NOID documents;O. NOID" },
      { label: "NOID Response", value: "NOID Response;O. NOID" },
    ],
  },
  {
    label: "P. Withdrawal",
    code: "L1PW",
    items: [{ label: "P. Withdrawal", value: "P. Withdrawal;P. Withdrawal" }],
  },
  {
    label: "Q. Others",
    code: "L1NO",
    items: [{ label: "Q. Others", value: "Q. Others;Q. Others" }],
  },
];

export const N400 =   [
  {
    label: "A. CH files and scans",
    code: "IN400ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "N400BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. Application package",
    code: "N400CAP",
    items: [
      {
        label: "C. Application package",
        value: "C. Application package;C. Application package",
      },
    ],
  },
  {
    label: 'D. Biographic documents',
    code: 'N400DBD',
    items: [
      { label: 'Arrest records', value: 'Arrest records;D. Biographic documents' },
      { label: 'Birth Certificates', value: 'Birth Certificates;D. Biographic documents' },
      { label: 'Green Cards', value: 'Green Cards;D. Biographic documents' },
      { label: 'Marriage Certificate', value: 'Marriage Certificate;D. Biographic documents' },
      { label: 'Other documents', value: 'Other documents;D. Biographic documents' },
      { label: 'Passports, I-551 stamp', value: 'Passports, I-551 stamp;D. Biographic documents' },
      { label: 'Tax Returns', value: 'Tax Returns;D. Biographic documents' },
      { label: 'Termination of Prior Marriages', value: 'Termination of Prior Marriages;D. Biographic documents' },
    ]
  },
  {
    label: "E. Forms",
    code: "N400EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Photos",
    code: "N400FP",
    items: [{ label: "F. Photos", value: "F. Photos;F. Photos" }],
  },
  {
    label: "G. Inquiries to USCIS",
    code: "N400ITU",
    items: [{ label: "G. Inquiries to USCIS", value: "G. Inquiries to USCIS;G. Inquiries to USCIS" }],
  },
  {
    label: "H. Inquiries to Ombudsman",
    code: "N400HITO",
    items: [{ label: "H. Inquiries to Ombudsman", value: "H. Inquiries to Ombudsman;H. Inquiries to Ombudsman" }],
  },
  {
    label: "I. Change of Address",
    code: "N400ICOA",
    items: [{ label: "I. Change of Address", value: "I. Change of Address;I. Change of Address" }],
  },
  {
    label: "J. Documents received from USCIS",
    code: "N400JDRFU",
    items: [{ label: "J. Documents received from USCIS", value: "J. Documents received from USCIS;J. Documents received from USCIS" }],
  },
  {
    label: "K. RFE",
    code: "N400KRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;K. RFE" },
      { label: "RFE Response", value: "RFE Response;K. RFE" },
    ],
  },
  {
    label: "L. NOID",
    code: "N400LNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;L. NOID" },
      { label: "NOID Response", value: "NOID Response;L. NOID" },
    ],
  },
  {
    label: "M. Withdrawal",
    code: "N400MW",
    items: [{ label: "M. Withdrawal", value: "M. Withdrawal;M. Withdrawal" }],
  },
  {
    label: "N. Others",
    code: "N400NO",
    items: [{ label: "N. Others", value: "N. Others;N. Others" }],
  },
];

export const O1 =  [
  {
    label: "A. CH files and scans",
    code: "O1ACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value:
          "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "O1BCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "N1CTBAC",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "O1DT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "O1EF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "O1FBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      {
        label: "Marriage Certificate",
        value: "Marriage Certificate;F. Biographic documents",
      },
      { label: "Passports, visas, I-94s", value: "Passports, visas, I-94s;F. Biographic documents" },
      {
        label: "Termination of Prior Marriages",
        value: "Termination of Prior Marriages;F. Biographic documents",
      },
    ],
  },
  {
    label: "G. Academic credentials",
    code: "O1GAC",
    items: [
      {
        label: "Academic evaluation",
        value: "Academic evaluation;G. Academic credentials",
      },
      {
        label: "Bachelors degree",
        value: "Bachelors degree;G. Academic credentials",
      },
      {
        label: "Certificates",
        value: "Certificates;G. Academic credentials",
      },
      {
        label: "Continuing Education",
        value: "Continuing Education;G. Academic credentials",
      },
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);G. Academic credentials",
      },
      {
        label: "Masters and doctorate degrees",
        value: "Masters and doctorate degrees;G. Academic credentials",
      },
      {
        label: "Other documents",
        value: "Other documents;G. Academic credentials",
      },
    ],
  },
  {
    label: "H. Work Experience",
    code: "O1HWE",
    items: [
      {
        label: "Curriculum Vitae (CV)",
        value: "Curriculum Vitae (CV);H. Work Experience",
      },
      {
        label: "Other documents",
        value:
          "Other documents;H. Work Experience",
      },
      {
        label: "Work Experience Letters (WELs)",
        value: "Work Experience Letters (WELs);H. Work Experience",
      },
    ],
  },
  {
    label: "I. Extraordinary Ability",
    code: "O1IEA",
    items: [
      {
        label: "Artistic Exhibitions or Showcases",
        value: "Artistic Exhibitions or Showcases;I. Extraordinary Ability",
      },
      {
        label: "High Remuneration",
        value: "High Remuneration;I. Extraordinary Ability",
      },
      {
        label: "Invited Talks, Review, and Judging Record",
        value: "Invited Talks, Review, and Judging Record;I. Extraordinary Ability",
      },
      {
        label: "Major Contribution to the Field",
        value: "Major Contribution to the Field;I. Extraordinary Ability",
      },
      {
        label: "Media and Publication Recognition",
        value: "Media and Publication Recognition;I. Extraordinary Ability",
      },
      {
        label: "Memberships",
        value: "Memberships;I. Extraordinary Ability",
      },
      {
        label: "Other documents",
        value: "Other documents;I. Extraordinary Ability",
      },
      {
        label: "Performance in a Leading or Major Role",
        value: "Performance in a Leading or Major Role;I. Extraordinary Ability",
      },
      {
        label: "Prizes or Awards",
        value: "Prizes or Awards;I. Extraordinary Ability",
      },
      {
        label: "Published Material and Citations",
        value: "Published Material and Citations;I. Extraordinary Ability",
      },
    ],
  },
  {
    label: "J. Job Offer in the U.S",
    code: "O1JOITUS",
    items: [
      {
        label: "J. Job Offer in the U.S",
        value: "J. Job Offer in the U.S;J. Job Offer in the U.S",
      },
   
    ],
  },
  {
    label: "K. US Petitioners documents",
    code: "O1KUSPD",
    items: [
      {
        label: "Articles of Incorporation or Organization",
        value: "Articles of Incorporation or Organization;K. US Petitioners documents",
      },
      {
        label: "Balance Sheet",
        value: "Balance Sheet;K. US Petitioners documents",
      },
      {
        label: "Companys description",
        value: "Companys description;K. US Petitioners documents",
      },
      {
        label: "Marketing material",
        value: "Marketing material;K. US Petitioners documents",
      },
      {
        label: "Membership or Share Certificate",
        value: "Membership or Share Certificate;K. US Petitioners documents",
      },
      {
        label: "Organizational Chart",
        value: "Organizational Chart;K. US Petitioners documents",
      },
      {
        label: "Other documents",
        value: "Other documents;K. US Petitioners documents",
      },
      {
        label: "Photos of the business",
        value: "Photos of the business;K. US Petitioners documents",
      },
      {
        label: "Profit and Loss (P and L)",
        value: "Profit and Loss (P and L);K. US Petitioners documents",
      },

      {
        label: "US Corporate Tax Return",
        value: "US Corporate Tax Return;K. US Petitioners documents",
      },
    ],
  },
  {
    label: "L. Writers",
    code: "O1LW",
    items: [{ label: "L. Writers", value: "L. Writers;L. Writers" }],
  },
  {
    label: "M. RFE",
    code: "O1MRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;M. RFE" },
      { label: "RFE Response", value: "RFE Response;M. RFE" },
    ],
  },
  {
    label: "N. NOID",
    code: "O1NNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;N. NOID" },
      { label: "NOID Response", value: "NOID Response;N. NOID" },
    ],
  },
  {
    label: "O. Withdrawal",
    code: "O1OW",
    items: [{ label: "O. Withdrawal", value: "O. Withdrawal;O. Withdrawal" }],
  },
  {
    label: "P. Others",
    code: "O1PO",
    items: [{ label: "P. Others", value: "P. Others;P. Others" }],
  },
];

export const TN =   [
  {
    label: "A. CH files and scans",
    code: "THACHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      {
        label: "From Onboarding",
        value: "From Onboarding;A. CH files and scans",
      },
      {
        label: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial)",
        value: "Notices from USCIS (Receipt, Biometrics, Approval, RFE, Denial);A. CH files and scans",
      },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "TNBCUF",
    items: [
      {
        label: "B. Client uploaded files",
        value: "B. Client uploaded files;B. Client uploaded files",
      },
    ],
  },
  {
    label: "C. TOC, Binder, and Checklist",
    code: "TNCTOCBAC",
    items: [
      {
        label: "C. TOC, Binder, and Checklist",
        value: "C. TOC, Binder, and Checklist;C. TOC, Binder, and Checklist",
      },
    ],
  },
  {
    label: "D. Translations",
    code: "TNDT",
    items: [
      { label: "1st Batch", value: "1st Batch;D. Translations" },
      { label: "2nd Batch", value: "2nd Batch;D. Translations" },
    ],
  },
  {
    label: "E. Forms",
    code: "TNEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. Biographic documents",
    code: "TNFBD",
    items: [
      {
        label: "Birth Certificates",
        value: "Birth Certificates;F. Biographic documents",
      },
      { label: "Change or extensions of status granted", value: "Change or extensions of status granted;F. Biographic documents" },
      { label: "I-94s", value: "I-94s;F. Biographic documents" },
      { label: "Marriage Certificate", value: "Marriage Certificate;F. Biographic documents" },
      { label: "Passports", value: "Passports;F. Biographic documents" },
      { label: "Termination of Prior Marriages", value: "Termination of Prior Marriages;F. Biographic documents" },
      { label: "Visas", value: "Visas;F. Biographic documents" },
    ],
  },
  {
    label: "G. Beneficiary qualifications (degrees, certificates)",
    code: "TNGBQDC",
    items: [
      { label: "Awards and recognitions", value: "Awards and recognitions;G. Beneficiary qualifications (degrees, certificates)", },
      { label: "Certificates", value: "Certificates;G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Curriculum Vitae (CV)", value: "Curriculum Vitae (CV);G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Diplomas", value: "Diplomas;G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Licenses", value: "Licenses;G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Other documents", value: "Other documents;G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Publications", value: "Publications;G. Beneficiary qualifications (degrees, certificates)" },
      { label: "Work experience", value: "Work experience;G. Beneficiary qualifications (degrees, certificates)" },
    ],
  },
  {
    label: "H. Job Offer in the U.S",
    code: "TNHJOITUS",
    items: [{ label: "H. Job Offer in the U.S", value: "H. Job Offer in the U.S;H. Job Offer in the U.S" }],
  },
  {
    label: "I. Consular Interview and documents",
    code: "TNICIAD",
    items: [{ label: "I. Consular Interview and documents", value: "I. Consular Interview and documents;I. Consular Interview and documents" }],
  },
  {
    label: "J. Writers",
    code: "TNJW",
    items: [{ label: "J. Writers", value: "J. Writers;J. Writers" }],
  },
  {
    label: "K. RFE",
    code: "TNKRFE",
    items: [
      { label: "RFE documents", value: "RFE documents;K. RFE" },
      { label: "RFE Response", value: "RFE Response;K. RFE" },
    ],
  },
  {
    label: "L. NOID",
    code: "TNLNOID",
    items: [
      { label: "NOID documents", value: "NOID documents;L. NOID" },
      { label: "NOID Response", value: "NOID Response;L. NOID" },
    ],
  },
  {
    label: "M. Withdrawal",
    code: "TNMW",
    items: [{ label: "M. Withdrawal", value: "M. Withdrawal;M. Withdrawal" }],
  },
  {
    label: "N. Others",
    code: "TNNO",
    items: [{ label: "N. Others", value: "N. Others;N. Others" }],
  },
];

export const WRITE_OF_MANDAMUS =   [
  {
    label: "A. CH files and scans",
    code: "WOMACAHFAS",
    items: [
      { label: "Filing Fee", value: "Filing Fee;A. CH files and scans" },
      { label: "From Onboarding", value: "From Onboarding;A. CH files and scans" },
      { label: "Notices from USCIS (Receipt, Approval, Denial)", value: "Notices from USCIS (Receipt, Approval, Denial);A. CH files and scans" },
    ],
  },
  {
    label: "B. Client uploaded files",
    code: "WOMBCUF",
    items: [{ label: "B. Client uploaded files", value: "B. Client uploaded files;B. Client uploaded files" }],
  },
  {
    label: "C. Filings",
    code: "WOMCF",
    items: [{ label: "C. Filings", value: "C. Filings;C. Filings" }],
  },
  {
    label: "D. Court documents",
    code: "WOMDCD",
    items: [{ label: "D. Court documents", value: "D. Court documents;D. Court documents" }],
  },
  {
    label: "E. Forms",
    code: "WOMEF",
    items: [{ label: "E. Forms", value: "E. Forms;E. Forms" }],
  },
  {
    label: "F. AOS",
    code: "WOMFAOS",
    items: [{ label: "F. AOS", value: "F. AOS;F. AOS" }],
  },
  {
    label: "G. I-526",
    code: "WOMGI",
    items: [{ label: "G. I-526", value: "G. I-526;G. I-526" }],
  },
  {
    label: "H. I-829",
    code: "WOMHI",
    items: [{ label: "H. I-829", value: "H. I-829;H. I-829" }],
  },
  {
    label: "I. Others",
    code: "WOMIO",
    items: [{ label: "I. Others", value: "I. Others;I. Others" }],
  },
];
// ------------ Folders End Here ----------------

export const manipulateFolderSelectionCommon = (selectedCaseFolder: any) => {
  switch (selectedCaseFolder) {
    case "AOS": 
      return AOS_FOLDERS
    case "CP":
      return CP_Folders
    case "E-1":
      return E1
    case "E-2":
      return E2     
    case "E-3":
      return E3
    case "EB-1A":
      return EB1A
    case "EB-1B":
      return EB1B
    case "EB-1C":
      return EB1C
    case "EB-2":
      return EB2
    case "EB-2 NIW":
      return EB2_NIW_FOLDERS
    case "EB-3":
      return EB3
    case "EB-5":
      return EB5
    case "H1-B":
      return H1B
    case "I-90":
      return I90
    case "I-131":
      return I131
    case "I-290B":
      return I290B
    case "I-765":
      return I765  
    case "I-824":
      return I824  
    case "I-829":
      return I829  
    case "L-1":
      return L1
    case "N-400":
      return N400
    case "O-1":
      return O1
    case "TN":
      return TN  
    case "Writ of Mandamus":
      return WRITE_OF_MANDAMUS
    default:
      return EB2_NIW_FOLDERS
  }
}

export const APPLICANT_NOT_SELECTED = "Please select atleast one applicant.";
export const DOC_CHK_LIST_NOT_SELECTED = "Please select atleast one document checklist item.";
export const UNSAVED_CHANGES_DOC_CHKLIST = "There are unsaved changes in selected checklist items. Please ensure you made required changes before clicking on submit button.";

// export const CASE_FOLDER_STRUCTURE = [
//   { label: "AOS", value: "AOS" },
//   { label: "CP", value: "CP" },
//   { label: "EB-2 NIW", value: "EB-2 NIW" },
//   { label: "EB-5", value: "EB-5" },
//   { label: "Writ of Mandamus", value: "Writ of Mandamus" },
//   { label: "E-2", value: "E-2" },
//   { label: "EB-1", value: "EB-1" },
//   { label: "EB-1A", value: "EB-1A" },
//   { label: "EB-1B", value: "EB-1B" }
// ];

export const CASE_FOLDER_STRUCTURE = [
  { label: "AOS", value: "AOS" },
  { label: "CP", value: "CP" },
  { label: "E-1", value: "E-1" }, //New
  { label: "E-2", value: "E-2" },
  { label: "E-3", value: "E-3" }, //New
  { label: "EB-1A", value: "EB-1A" },
  { label: "EB-1B", value: "EB-1B" },
  { label: "EB-1C", value: "EB-1C" }, // New
  { label: "EB-2", value: "EB-2" }, // New
  { label: "EB-2 NIW", value: "EB-2 NIW" },
  { label: "EB-3", value: "EB-3" }, // New
  { label: "EB-5", value: "EB-5" },
  { label: "H1-B", value: "H1-B" }, // New
  { label: "I-90", value: "I-90" }, // New
  { label: "I-131", value: "I-131" }, // New
  { label: "I-290B", value: "I-290B" }, // New
  { label: "I-765", value: "I-765" }, // New
  { label: "I-824", value: "I-824" }, // New
  { label: "I-829", value: "I-829" }, // New
  { label: "L-1", value: "L-1" }, // New
  { label: "N-400", value: "N-400" }, // New
  { label: "O-1", value: "O-1" }, // New
  { label: "TN", value: "TN" }, // New
  { label: "Writ of Mandamus", value: "Writ of Mandamus" },
  // { label: "EB-1", value: "EB-1" }, // Deleted
];

export const CASE_DOCUMENT_ACTION = {
  Requested: {
    title: "Request Document ",
    body: "Are you sure, you want to Request the Document?"
  },
  ReRequested: {
    title: "Re-Request Document ",
    body: "Are you sure, you want to Re-Request the Document?"
  },
  Received: {
    title: "Mark document as Received",
    body: "Are you sure, you want to mark the document as Received?"
  },
  Approve: {
    title: "Mark document as Approve",
    body: "Are you sure, you want to mark the document as Approved?"
  },
  Sign: {
    title: "Mark document as Signed",
    body: "Are you sure, you want to mark the document as Signed?"
  },
  ReRequestAll: {
    title: "Request Documents",
    body: "Are you sure, you want to Mark Requested, all the selected documents?"
  }
}

export const CASE_FORM_ACTION = {
  Sent: {
    title: "Send form ",
    body: "Are you sure, you want to Send the form?"
  },
  Approve: {
    title: "Mark form as Approve",
    body: "Are you sure, you want to mark the form as Approved?"
  },
  Sign: {
    title: "Mark form as Signed",
    body: "Are you sure, you want to mark the form as Signed?"
  }
}

export const VISA_CATEGORY_OPTIONS = [
  { label: "Employment - 1st", value: "Employment - 1st" },
  { label: "Employment - 2nd", value: "Employment - 2nd" },
  { label: "Employment - 3rd", value: "Employment - 3rd" },
  { label: "Employment - 4th", value: "Employment - 4th" },
  { label: "Employment - Other Workers", value: "Employment - Other Workers" },
  { label: "5th Non-Regional Center (C5 and T5)", value: "5th Non-Regional Center (C5 and T5)" },
  { label: "5th Regional Center (I5 and R5)", value: "5th Regional Center (I5 and R5)" },
  { label: "Family Based", value: "Family Based" },
];


export const RECEIVED_FROM_OPTIONS = [
  { label: "USCIS – California Service Center", value: "USCIS – California Service Center" },
  { label: "USCIS – Nebraska Service Center", value: "USCIS – Nebraska Service Center" },
  { label: "USCIS – Potomac Service Center", value: "USCIS – Potomac Service Center" },
  { label: "USCIS – Texas Service Center", value: "USCIS – Texas Service Center" },
  { label: "USCIS – Vermont Service Center", value: "USCIS – Vermont Service Center" },
  { label: "USCIS Field Office", value: "USCIS Field Office" },
  { label: "USCIS Asylum Office", value: "USCIS Asylum Office" },
  { label: "HART Service Center", value: "HART Service Center" },
  { label: "US Department of State", value: "US Department of State" },
  { label: "DOL - Department of Labor", value: "DOL - Department of Labor" },
  { label: "NBC - National Benefits Center", value: "NBC - National Benefits Center" },
  { label: "NVC - National Visa Center", value: "NVC - National Visa Center" },
  { label: "SWA – State Workforce Agency", value: "SWA – State Workforce Agency" },
  { label: "Other", value: "Other" },
];

export const NOTICE_TYPE_OPTIONS = [
  { label: "Receipt Notice", value: "Receipt Notice" },
  { label: "RFE Notice", value: "RFE Notice" },
  { label: "NOID Notice", value: "NOID Notice" },
  { label: "Approval Notice", value: "Approval Notice" },
  { label: "Withdrawal Decision", value: "Withdrawal Decision" },
  { label: "Denial Decision", value: "Denial Decision" },
  { label: "Transfer Notice", value: "Transfer Notice" },
  { label: "Biometrics Notice", value: "Biometrics Notice" },
  { label: "Interview Notice", value: "Interview Notice" },
  { label: "NVC Notice", value: "NVC Notice" },
  { label: "NVC Invoice", value: "NVC Invoice" },
  { label: "IV Fee Payment Receipt", value: "IV Fee Payment Receipt" },
  { label: "AOS Fee Payment Receipt", value: "AOS Fee Payment Receipt" },
  { label: "NVC RFE", value: "NVC RFE" },
  { label: "NVC Documentarily Complete", value: "NVC Documentarily Complete" },
  { label: "Termination Letter", value: "Termination Letter" },
  { label: "Revocation Notice", value: "Revocation Notice" },
  { label: "AA Confirmation Number", value: "AA Confirmation Number" },
  { label: "Perm Prevailing Wage", value: "Perm Prevailing Wage" },
  { label: "Other", value: "Other" },
];

export const RECEIPT_STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "RFE", value: "RFE" },
  { label: "NOID", value: "NOID" },
  { label: "Withdrawn", value: "Withdrawn" },
  { label: "Denied", value: "Denied" },
  { label: "Approved", value: "Approved" },
  { label: "Refile", value: "Refile" },
  { label: "Appeal", value: "Appeal" },
];

export const NOTIFY_ON_OPTIONS = [
  { label: "Both", value: "both" },
  { label: "Email", value: "email" },
  { label: "Bell", value: "bell" },
];

export const REMINDER_STATUS_OPTIONS = [
  { label: "Status: All", value: "" },
  { label: "Completed", value: "Completed" },
  { label: "Upcoming", value: "Upcoming" },
  { label: "Overdue", value: "Overdue" },
];

export const REMINDER_TIME_OPTIONS = [
  { label: "8 AM", value: "08:00:00" },
  { label: "9 AM", value: "09:00:00" },
  { label: "10 AM", value: "10:00:00" },
  { label: "11 AM", value: "11:00:00" },
  { label: "12 PM", value: "12:00:00" },
  { label: "1 PM", value: "13:00:00" },
  { label: "2 PM", value: "14:00:00" },
  { label: "3 PM", value: "15:00:00" },
  { label: "4 PM", value: "16:00:00" },
  { label: "5 PM", value: "17:00:00" },
  { label: "6 PM", value: "18:00:00" },
  { label: "7 PM", value: "19:00:00" },
  { label: "8 PM", value: "20:00:00" },
];

export const YES_NO_OPTIONS = [
  { label: "Select", value: "" },
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const EVENT_TYPES_OPTIONS = [
  { label: "Appointment", value: "Appointment" },
  { label: "Court Date", value: "Court Date" },
  { label: "Interview", value: "Interview" },
  { label: "Meeting", value: "Meeting" },
  { label: "Other", value: "Other" }
];

export const EVENTS_TIME_OPTIONS = [
  { "label": "06:00:00", "value": "06:00:00" },
  { "label": "06:30:00", "value": "06:30:00" },
  { "label": "07:00:00", "value": "07:00:00" },
  { "label": "07:30:00", "value": "07:30:00" },
  { "label": "08:00:00", "value": "08:00:00" },
  { "label": "08:30:00", "value": "08:30:00" },
  { "label": "09:00:00", "value": "09:00:00" },
  { "label": "09:30:00", "value": "09:30:00" },
  { "label": "10:00:00", "value": "10:00:00" },
  { "label": "10:30:00", "value": "10:30:00" },
  { "label": "11:00:00", "value": "11:00:00" },
  { "label": "11:30:00", "value": "11:30:00" },
  { "label": "12:00:00", "value": "12:00:00" },
  { "label": "12:30:00", "value": "12:30:00" },
  { "label": "13:00:00", "value": "13:00:00" },
  { "label": "13:30:00", "value": "13:30:00" },
  { "label": "14:00:00", "value": "14:00:00" },
  { "label": "14:30:00", "value": "14:30:00" },
  { "label": "15:00:00", "value": "15:00:00" },
  { "label": "15:30:00", "value": "15:30:00" },
  { "label": "16:00:00", "value": "16:00:00" },
  { "label": "16:30:00", "value": "16:30:00" },
  { "label": "17:00:00", "value": "17:00:00" },
  { "label": "17:30:00", "value": "17:30:00" },
  { "label": "18:00:00", "value": "18:00:00" },
  { "label": "18:30:00", "value": "18:30:00" },
  { "label": "19:00:00", "value": "19:00:00" },
  { "label": "19:30:00", "value": "19:30:00" },
  { "label": "20:00:00", "value": "20:00:00" },
  { "label": "20:30:00", "value": "20:30:00" },
  { "label": "21:00:00", "value": "21:00:00" },
  { "label": "21:30:00", "value": "21:30:00" },
  { "label": "22:00:00", "value": "22:00:00" }
]

// Reason for Closure Options
export const REASON_FOR_CLOUSURE_OPTIONS = [
  { label: "Approved", value: "Approved" },
  { label: "Denied", value: "Denied" },
  { label: "MTR", value: "MTR" },
  { label: "Refile", value: "Refile" },
  { label: "Withdrawn", value: "Withdrawn" },
  { label: "Termination of Representation", value: "Termination of Representation" }
]

export const STATE_OPTIONS = [
  {
    label: "AA",
    value: "AA",
  },
  {
    label: "AE",
    value: "AE",
  },
  {
    label: "AK",
    value: "AK",
  },
  {
    label: "AL",
    value: "AL",
  },
  {
    label: "AP",
    value: "AP",
  },
  {
    label: "AR",
    value: "AR",
  },
  {
    label: "AS",
    value: "AS",
  },
  {
    label: "AZ",
    value: "AZ",
  },
  {
    label: "CA",
    value: "CA",
  },
  {
    label: "CO",
    value: "CO",
  },
  {
    label: "CT",
    value: "CT",
  },
  {
    label: "DC",
    value: "DC",
  },
  {
    label: "DE",
    value: "DE",
  },
  {
    label: "FL",
    value: "FL",
  },
  {
    label: "FM",
    value: "FM",
  },
  {
    label: "GA",
    value: "GA",
  },
  {
    label: "GU",
    value: "GU",
  },
  {
    label: "HI",
    value: "HI",
  },
  {
    label: "IA",
    value: "IA",
  },
  {
    label: "ID",
    value: "ID",
  },
  {
    label: "IL",
    value: "IL",
  },
  {
    label: "IN",
    value: "IN",
  },
  {
    label: "KS",
    value: "KS",
  },
  {
    label: "KY",
    value: "KY",
  },
  {
    label: "LA",
    value: "LA",
  },
  {
    label: "MA",
    value: "MA",
  },
  {
    label: "MD",
    value: "MD",
  },
  {
    label: "ME",
    value: "ME",
  },
  {
    label: "MH",
    value: "MH",
  },
  {
    label: "MI",
    value: "MI",
  },
  {
    label: "MN",
    value: "MN",
  },
  {
    label: "MO",
    value: "MO",
  },
  {
    label: "MP",
    value: "MP",
  },
  {
    label: "MS",
    value: "MS",
  },
  {
    label: "MT",
    value: "MT",
  },
  {
    label: "NC",
    value: "NC",
  },
  {
    label: "ND",
    value: "ND",
  },
  {
    label: "NE",
    value: "NE",
  },
  {
    label: "NH",
    value: "NH",
  },
  {
    label: "NJ",
    value: "NJ",
  },
  {
    label: "NM",
    value: "NM",
  },
  {
    label: "NV",
    value: "NV",
  },
  {
    label: "NY",
    value: "NY",
  },
  {
    label: "OH",
    value: "OH",
  },
  {
    label: "OK",
    value: "OK",
  },
  {
    label: "OR",
    value: "OR",
  },
  {
    label: "PA",
    value: "PA",
  },
  {
    label: "PR",
    value: "PR",
  },
  {
    label: "PW",
    value: "PW",
  },
  {
    label: "RI",
    value: "RI",
  },
  {
    label: "SC",
    value: "SC",
  },
  {
    label: "SD",
    value: "SD",
  },
  {
    label: "TN",
    value: "TN",
  },
  {
    label: "TX",
    value: "TX",
  },
  {
    label: "UT",
    value: "UT",
  },
  {
    label: "VA",
    value: "VA",
  },
  {
    label: "VI",
    value: "VI",
  },
  {
    label: "VT",
    value: "VT",
  },
  {
    label: "WA",
    value: "WA",
  },
  {
    label: "WI",
    value: "WI",
  },
  {
    label: "WV",
    value: "WV",
  },
  {
    label: "WY",
    value: "WY",
  },
];

// Settings fields mapped with Mapping of Organistions
export const QUESTIONNAIRE_QUESTIONS_OPTIONS = [
  { label: "ID", value: "ID" },
  { label: "Name", value: "Name" },
  { label: "Tax ID", value: "Tax ID" },
  { label: "Website", value: "Website" },
  { label: "Contact Name", value: "Contact Name" },
  { label: "Firm Name on Form", value: "Firm Name and Form" },

  { label: "Enabled Address - Full Address", value: "Enabled Address - Full Address" },
  { label: "Enabled Address - Phone Number", value: "Enabled Address - Phone Number" },
  { label: "Enabled Address - Fax Number", value: "Enabled Address - Fax Number" },
  { label: "Enabled Address - Mobile Number", value: "Enabled Address - Mobile Number" },
  { label: "Enabled Address - Email", value: "Enabled Address - Email" },
  { label: "Enabled Address - Street Number and Name", value: "Enabled Address - Street Number and Name" }, // New
  { label: "Enabled Address - Apt. Ste. Flr. Selection",value: "Enabled Address - Apt. Ste. Flr. Selection", valueObj: {option_values: [{label:"Apt." , value:"Apt." },{label:"Ste." , value:"Ste." },{label:"Flr." , value:"Flr." }], question_type:"Checkbox"}  }, // New
  { label: "Enabled Address - Apt. Ste. Flr. Number", value: "Enabled Address - Apt. Ste. Flr. Number" }, // New
  { label: "Enabled Address - State", value: "Enabled Address - State" }, // New
  { label: "Enabled Address - Zip Code/Post Code", value: "Enabled Address - Zip Code/Post Code" }, // New
  { label: "Enabled Address - Province", value: "Enabled Address - Province" }, // New
  { label: "Enabled Address - City", value: "Enabled Address - City" }, // New
  { label: "Enabled Address - Country", value: "Enabled Address - Country" }, // New

  { label: "Main Address on Forms - Full Address", value: "Main Address on Forms - Full Address" },
  { label: "Main Address on Forms - Phone Number", value: "Main Address on Forms - Phone Number" },
  { label: "Main Address on Forms - Fax Number", value: "Main Address on Forms - Fax Number" },
  { label: "Main Address on Forms - Mobile Number", value: "Main Address on Forms - Mobile Number" },
  { label: "Main Address on Forms - Email", value: "Main Address on Forms - Email" },
  { label: "Main Address on Forms - Street Number and Name", value: "Main Address on Forms - Street Number and Name" }, // New
  { label: "Main Address on Forms - Apt. Ste. Flr. Selection", value: "Main Address on Forms - Apt. Ste. Flr. Selection",  valueObj: {option_values: [{label:"Apt." , value:"Apt." },{label:"Ste." , value:"Ste." },{label:"Flr." , value:"Flr." }], question_type:"Checkbox"} }, // New
  { label: "Main Address on Forms - Apt. Ste. Flr. Number", value: "Main Address on Forms - Apt. Ste. Flr. Number" }, // New
  { label: "Main Address on Forms - State", value: "Main Address on Forms - State" }, // New
  { label: "Main Address on Forms - Zip Code/Post Code", value: "Main Address on Forms - Zip Code/Post Code" }, // New
  { label: "Main Address on Forms - Province", value: "Main Address on Forms - Province" }, // New
  { label: "Main Address on Forms - City", value: "Main Address on Forms - City" }, // New
  { label: "Main Address on Forms - Country", value: "Main Address on Forms - Country" }, // New

  { label: "Office Address on Forms - Full Address", value: "Office Address on Forms - Full Address" },
  { label: "Office Address on Forms - Phone Number", value: "Office Address on Forms - Phone Number" },
  { label: "Office Address on Forms - Fax Number", value: "Office Address on Forms - Fax Number" },
  { label: "Office Address on Forms - Mobile Number", value: "Office Address on Forms - Mobile Number" },
  { label: "Office Address on Forms - Email", value: "Office Address on Forms - Email" },
  { label: "Office Address on Forms - Street Number and Name", value: "Office Address on Forms - Street Number and Name" }, // New
  { label: "Office Address on Forms - Apt. Ste. Flr. Selection", value: "Office Address on Forms - Apt. Ste. Flr. Selection",  valueObj: {option_values: [{label:"Apt." , value:"Apt." },{label:"Ste." , value:"Ste." },{label:"Flr." , value:"Flr." }], question_type:"Checkbox"} }, // New
  { label: "Office Address on Forms - Apt. Ste. Flr. Number", value: "Office Address on Forms - Apt. Ste. Flr. Number" }, // New
  { label: "Office Address on Forms - State", value: "Office Address on Forms - State" }, // New
  { label: "Office Address on Forms - Zip Code/Post Code", value: "Office Address on Forms - Zip Code/Post Code" }, // New
  { label: "Office Address on Forms - Province", value: "Office Address on Forms - Province" }, // New
  { label: "Office Address on Forms - City", value: "Office Address on Forms - City" }, // New
  { label: "Office Address on Forms - Country", value: "Office Address on Forms - Country" }, // New
  
  { label: "Alternative Address on Forms - Full Address", value: "Alternative Address on Forms - Full Address" },
  { label: "Alternative Address on Forms - Phone Number", value: "Alternative Address on Forms - Phone Number" },
  { label: "Alternative Address on Forms - Fax Number", value: "Alternative Address on Forms - Fax Number" },
  { label: "Alternative Address on Forms - Mobile Number", value: "Alternative Address on Forms - Mobile Number" },
  { label: "Alternative Address on Forms - Email", value: "Alternative Address on Forms - Email" },
  { label: "Alternative Address on Forms - Street Number and Name", value: "Alternative Address on Forms - Street Number and Name" }, // New
  { label: "Alternative Address on Forms - Apt. Ste. Flr. Selection", value: "Alternative Address on Forms - Apt. Ste. Flr. Selection",  valueObj: {option_values: [{label:"Apt." , value:"Apt." },{label:"Ste." , value:"Ste." },{label:"Flr." , value:"Flr." }], question_type:"Checkbox"} }, // New
  { label: "Alternative Address on Forms - Apt. Ste. Flr. Number", value: "Alternative Address on Forms - Apt. Ste. Flr. Number" }, // New
  { label: "Alternative Address on Forms - State", value: "Alternative Address on Forms - State" }, // New
  { label: "Alternative Address on Forms - Zip Code/Post Code", value: "Alternative Address on Forms - Zip Code/Post Code" }, // New
  { label: "Alternative Address on Forms - Province", value: "Alternative Address on Forms - Province" }, // New
  { label: "Alternative Address on Forms - City", value: "Alternative Address on Forms - City" }, // New
  { label: "Alternative Address on Forms - Country", value: "Alternative Address on Forms - Country" }, // New

  { label: "Terms of use", value: "Terms of use" }
];

// DASHBOARD RECENTLY VISITED OPTIONS
export const RECENTLY_VISITED_OPTIONS = [
  { label: "All", value: "" },
  { label: "Case", value: "Case" },
  { label: "Client", value: "Client" },
];

// DASHBOARD TODAY WEEKLY MONTHLY OPTIONS
export const TODAY_WEEK_MONTH_OPTIONS = [
  { label: "Today", value: "" },
  { label: "This Week", value: "Weekly" },
  { label: "This Month", value: "Monthly" },
];

// DASHBOARD MONTH QUATER YEAR OPTIONS
export const MONTH_QUATER_YEAR_OPTIONS = [
  { label: "Monthly", value: "month" },
  { label: "Quarterly", value: "quarter" },
  { label: "Yearly", value: "year" },
];

export const APT_STE_FLR_SELECTION_OPTIONS = [
  {id: "Apt.", value: "Apt. "},
  {id: "Ste.", value: "Ste. "},
  {id: "Flr.", value: "Flr. "}
]

// DASHBOARD QUATER HALLYYEARL YEAR OPTIONS
export const QUATER_HALFYEARLY_YEAR_OPTIONS = [
  { label: "Quarterly", value: "quarter" },
  { label: "Half Yearly", value: "halfYear" },
  { label: "Yearly", value: "year" },
];

// DASHBOARD STAGE CASE PROGRESS COLOUR
// export const STAGE_CASE_PROGRESS_COLOURS = ["green", "red", "yellow", "pink", "purple", "orange", "blue", "Plum", "Wheat", "Turquoise", "Peru", "Teal", "Maroon","black", "Magenta", "Indigo"];
export const STAGE_CASE_PROGRESS_COLOURS = ["#052865", "#B5222E", "#E1C233", "#80BD67", "#E66C37", "#AFA46E", "#C1D3F6", "#021B44", "#E74C3C", "#F9E79F", "#276747", "#FFA07A", "#BDC3C7", "#16A085", "#8E44AD", "#FFC0CB", "#87CEEB", "#7D3C98" ];

// STATUS ACTIVE INACTIVE
export const STATUS_ACTIVE_INACTIVE_OPTIONS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

// MONTH NUMBER IN STRING
export const MONTH_NUMBER_IN_STRING = [
  { label: "01", value: "January" },
  { label: "02", value: "February" },
  { label: "03", value: "March" },
  { label: "04", value: "April" },
  { label: "05", value: "May" },
  { label: "06", value: "June" },
  { label: "07", value: "July" },
  { label: "08", value: "August" },
  { label: "09", value: "September" },
  { label: "10", value: "October" },
  { label: "11", value: "November" },
  { label: "12", value: "December" },
];

// export const SIGNATURE_DUMMY = 
//   `<figure class="table" style="width:100%;">
//     <table class="ck-table-resized">
//         <tbody>
//           <tr>
//               <td>
//                 <figure class="image" style="width:80px;">
//                   <img src="data:image/png;base64,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"
//                     alt="Signature Default" width="70" height="70" />
//                 </figure>
//               </td>
//               <td style="width:90%;"><span style="color:rgb(11,27,108)!important;"><strong>Enter Full Name</strong></span><br><span style="color:rgb(11,27,108)!important;">Enter Designation</span></td>
//           </tr>
//           <tr>
//               <td colspan="2"><span style="color:rgb(9,57,106)!important;">☎ Direct Phone:&nbsp;407.476.2064</span><br><span style="color:rgb(9,57,106)!important;">&nbsp;</span><span style="color:inherit;"><img class="image_resized" style="aspect-ratio:16/16;height:9pt;width:7.49pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUtJREFUOE+NkkFSg0AQRX9D4sYNlqHKZY6Ai8S4Ek+AniDxBnoDPIFXwBvoCcSlwarkBolrScnaMN1mKMEQMDCrmeo/b+b/boLlWOgeeCaTKwZfAZTw+vsUyTxBi0WGPVwQ0N/WirDP8ft9i/sg0x5KRSiSqDg6agkYfAFk7YqViIs4em2CaAszApwa4UR9Th+bAb3BAxHdljKABLw+vEMSNgZJ6J1fmKTCAiB4UvH0uunlvE56Y9rDBfJO6ADT1EEy+2gDyQHjDSD4+4WEKo4uWwO0cDdMYQl4Fd0UkGzgumOwscTq7blkITucjPqmUrNSS0VClaYTbcfYCluAJTN8qHWYWcjXJouyFV0Q0Z2Yg8jdtaRBJUAmOD7zTIODuuGqyaQGUNjhl6Iz/6ZJQfUHVUv+HtBkLyBndXojFxBPSI88O7/2lqrTcX8AGYV+12jnySEAAAAASUVORK5CYII=" alt="fa6-solid_phone (1).png" width="16" height="16"></span><span style="color:rgb(9,57,106)!important;"> Office Phone:&nbsp;407.478.1111</span><br><span style="color:rgb(11,27,108)!important;"><img class="image_resized" style="aspect-ratio:22/24;height:14.99pt;width:13.5pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAAXNSR0IArs4c6QAAAZlJREFUSEvtlE9OwlAQxr/pHyRhwxG6MSmsygmsJ1BPIEaauDOeQLxBNy4UTOoJwBOgJ8AdZWW9AUsiz46ppuQV+9qGhLjxLTszv/f1ezND2NGhHXHxD147+3dWGLZ3AHAfBIeYmky8YOYxQQtEOHhRPb5asdVtGnVjRCBXVczEvpgNr/LiSrBh9yZF0BSmgueCdfv8VIMWVO1xBtxNW3LBpu1NAMgWRDrV3OXs9t1sew5ijABYa9XMvphnLVGBWVbL4EMRDp/Tb2bLuwTDl+x4FbNhR66pBNapZiVq00K93TvSYhpvA36TfzVGHHyGD2ffIKvbNOvmNGsFxmI+OClVbNi9awL1Nx4vYnCU9nM2Rt1VeP9YCjb3PQc6ElVVTrRarjqIgkUpOEnI6YzcSxjcF+HwZjOoHJC6fWEJEtNkjAtkR41lo7OI/IzaJL9wCSm8lu757W0aLN1uZsubguHkqA5W4eCnU3JOKVhhidKCyoqTRHkgkrVpYM+RB2YrxWlR6jexdvwxv3sq68NSK2SAYfdceWcUwb8AcY6mGVUVpeQAAAAASUVORK5CYII=" alt="mdi_location (1).png" width="22" height="24"> 301 E Pine St,&nbsp;Suite 450, Orlando, FL 32801</span><br><span style="color:inherit;"><img class="image_resized" style="aspect-ratio:24/24;height:15.99pt;width:15.99pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAltJREFUSEvtVUFy00AQ7FlJONz8BOeETA4xL0C8IOYFGBIV3BJegjlwoGzKzgswL0C8wOYAkbnE/MAcqEpK8g6atWRLsmJCUS4u7HFr1T3dM9Mi7PjQjvHxn+C3Dv97i2zXf0hAB4AHoGFKZkw06QmYRotp/8M2GTcrcDsNG/aAQAK87cwi0h4u3n2velRNcPDs0NYqIKZ6UnmQfugxcxcKIKYzJoyIMQfQYeY5seVF395+LpNsEkjlZI8NOOMsmvZeO65/mYDXbVVrXdV+/rCv7UtoIL6O952a8wSErpDEiltlJRsEAma8TsGt+ydHStMouRtGYe+pVGg3T14ZFYAXh71Pzj3/1JCAgzjsP8qrKBBkYEYyGVBpaAuElnxMoNnyihumN4wJCBNzR9wW1RlpRlIkcI8HCkom5m/OSqmAFAicpj9mzQ0QHq8YCO8TO+YMNvasK6OBWMngtSXp2yjs7VcqcFyfE6mT+KL/IHtg7iq8dVz/o+xGFPZWRWb9y98VFbg+J2M3y1fwRwRNfyw920ZgxhFE7ZxE2YMZL7c5ZxGG5bcglsGY5R0oKxBfd9fkNHeCwpimGXTbMdWK24uv63yqWjTTvGzRcqTdeNp/KR5Z6ThnYE7TPwWjW+7fxpjKxZ77ohFTvI6Ku9F5Phqwh3oaJXMZhgyciec2aq2rizeF0KsMO+fg+SHrhQk7DT1MYqCuWLWZWDKnLssoli0rJE/ASVle9OU2YZfOiShZYCF2Lf8BN5/AojudcuWVi1aFYTWP24rVkeSRyaXlkUwKGHweh/0szitL+AWpxk0oQpAL1wAAAABJRU5ErkJggg==" alt="mdi_web.png" width="24" height="24"></span><span style="color:rgb(11,27,108)!important;"> </span><a href="http://www.colombohurdlaw.com/"><span style="color:rgb(0,40,80)!important;">www.colombohurdlaw.com</span></a><br><br><span style="color:inherit;"><img class="image_resized" style="aspect-ratio:187/42;height:42px;width:187px;" src="data:image/png;base64,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" alt="Colombo &amp; Hurd, PL" width="500" height="112"> &nbsp;</span><a href="https://www.linkedin.com/company/colombo-&amp;-hurd/"><span style="background-color:white!important;color:blue!important;"><img class="image_resized" style="aspect-ratio:50/50;height:20.49pt;width:20.49pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAplJREFUaEPtWUtyGjEQVQ9VFEtyA3wDbhDnBCHFBmkWwA2SE9g+QcgJBi+QtIt9gjgnyBFCThC2LKjOtEukZqZ6xpj5mpI2rjIaqV+/7qduCcSFDLgQHMID6RqTnpE3x4jW+j0ALIQQozaMR8QdIq7DMHws2r8wtIwxN/HHt20AYPa8lVLe5dmSC8Ra+xERHzoC4tkMRLxWSv3kbCoC8h0RJ10CEof3Wkq5fBUQY8wPIcQ1+xEAxe2uhbx5klJ+KA0EAHaHw2FxTDxjDAnAvME8qgYIIi6UUvdZjxSxV3FolgdCoaSUescZ1qAwlAcihNhKKa84IJvNZhwEwa+Kvc8tVx4IMbLf76+WyyUleWporecAsH4TQJyOr5RSX5IGR1E0GgwGpHBNnPzlGUkYv6aSIU78ba/Xm8RMfW4IBJlQKZAGIih3Cw+EPdkromRLSkhrAcAYEYcnrFsNI/FmKwD4lt0QAKguGyf+T2XEs5GJQWJAovAU234npaS//4dTPqq0i0SjGiBUinCldPZk7/f7o+l0+idpqCtnbvKKvuNcY0wUO4H6n3rOEbfq2UCiKBpyZxBnbUHJ0z4jJ8R/MsyoK02FnvuxO0COrbNrYVdhGKZCMBFiXBvRDSDZ1tmBGXNgrLVf3WGbJLMbQKy1fxmZZbu+nPuC9oE41frN5AprnAeS9VSOBJ4tv56RtId9jmSLRh9aPkd8jjgPXLr8UkXKVaWp9xPXgKWujQBgyNRO5DZqwLirJBKarNhUJr+vqcbrmHsWkKJOrQ4jX1yT3muUUp+4ibnvI65v4MLoxQ3rmgAAk9lsxj7BXf7T29GrWutJEATzE69r6iCDxOA+e+uS3ci/s9fh+jJrekbKeK+Obz0jdXi1zJr/AHPmOVEjudr8AAAAAElFTkSuQmCC" width="50" height="50"></span></a><span style="color:inherit;"> &nbsp;</span><a href="https://www.instagram.com/colomboandhurd/"><span style="background-color:white!important;color:blue!important;"><img class="image_resized" style="aspect-ratio:50/50;height:20.49pt;width:20.49pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAA5NJREFUaEPtWUtyGjEQHW347MgN8AmMTxB8gjjFBomFzQnsnCDkBHFOMGSDZpf4BCEnMDmByQns5bAZRT3RUIMYjbozHiAUVLnKBfr06yf1626x4Eg+7EhwBCcgh8bkiZH/npEwDDvNZvM8CIKrIAi6jLEegGKMdZRSHQpAxtiLUir9M/8vlFLz0Wj0QFkn3R87AQC0Wq1bveEd1WDsHrlxS+2kaRzHX8bj8QtmPgpIGIbdVqv1AxjALPqKY5ZJkvRHo9Fv35peIHsEkdmOAlMKxBynxz0wYROwjOP4ouyYlQKRUn7UK058tO7o9wnn/JNrLx+Qpx2yMTdG9ouMhci2Wq3OXKw4gURR9E4p9X0X3maMXQ2HwzTkRlF0rpRaOMD0hRA/i34rA/JZe+FuB0DmnPPL/D5SSoiQW8zosH8vhPhAAuJaDAtMexnEDTwLmgCCCcLZ1SynApp9YIwQ4iL/nWblm/4eBHfjAydECPGeBEQfrUd7UySISZmQSSlBiyCI3OTArI9M2dECp3DOz0hApJTUi740Z/0XBvBsNnvLGJtmwQS8DWkKrFGSOdCBRFH0TEhFlo1Goz8YDLwKbN0FYAedMUDkEkK8oTKiMJ6FMY1Go2uDMBnBtbkXkEwu4bLa6YZhJgu93i21lhQGKGfU0mKIBbIlVJrNWzDaYdXWeCllmL8zZWhqA2KzgckG7DBKYaUWIHY4NMcJgoT3o+uODXHDBpdagGhrN44Jho1cyN0QN+zxqgWIUupGCPE1M84lZA56NhQd64SdAMF61QA7HCBVjhaUspzzMZXNWhjRid2GV00h9uy96X8HXHLO1/qBTYlqAVJUI3g0JEVgh19KtKsFiPF8kcA5K8uiVJxyt2oDYvpSPTv1MFnuddb3SpIEksqH/HECR1DEEMaTgVCTRmzbJn9/qB2af00ayWk8BYydxiMDBD2Nx6YMBQZMkySZuJpqBgAUVevCCgkCgsRWNZnNLavZC8tNyqYQnqFYMnOg9oA6vEq3cqu+xwDZVfMB65utsJ2f6GSEGk3Q1lQYmG8b2cs4gYBKt9vtJ0K5W8FE1FTnRYfZvk7jcbRMj6aJDZQZhUZ3OlCHhDYI1aHxvo/sGQwKhPeOWOlE+vRmhKyKFnj5MO+J96/+9GbvPJvNoC8LncJe9gha5TE09ShjiyyxjON4gX079Aqi120HNgB1Rw7M5kJzTkAOjaUTI4fGyB/wWVNR5cvQKgAAAABJRU5ErkJggg==" width="50" height="50"></span></a><span style="color:inherit;"> &nbsp;&nbsp;</span><a href="https://www.youtube.com/channel/UCWWZGKswGzpEvZUTLrhlAJw"><span style="background-color:white!important;color:blue!important;"><img class="image_resized" style="aspect-ratio:50/50;height:20.49pt;width:20.49pt;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAthJREFUaEPtWUtym0AQnYZSATv5BFZuoJwguYFcpY2ARZQTSDmBdAPrBmjDZ2fnBPEN7Jwg8gnipTaaCY8AhVVIyGIGfQo2Rh6m4fXrz3Q3sSu56EpwsBbIuTHZMtIyokgD129avu/fMsb6RNQlol6qyOwvfu66z3WOvUKIbgUJq2xdCPFGRG/4Xbhf4X+bzWal6/pqNBr9LpP3jhHP83qGYUw0TRsf8AGKjGS/WIASQjxyzueu675mT+dAfN8f6Lq+PFcA2/DAmBBi7LruT6wlQMCEZVnPlwKiaIoxO30wkwAJw9BjjI1PYis1Xxorf+E4zo8ESBRFfy+NjSIrjuPckO/7fU3Tnmsq5qTbOeefKYqiAaLASb+k5svh9BSG4SyWM68p66TbOedTMPIghLiT+CVIcMVkKVF0uSg4PBj5xRj7KvFtn4hoEsf5qUSZVaKWYAT5o1/15KHrtm1nIR2swGybCOtPYOSPTFPIgGTAwzAE28hTKs3tCYxIzSHbQDJAQRB8IyIEFRWAVmBEHGo2hzy3C0iBoVl88JtKTsDNA0mPRLL95zRACuz0iOheRvhv3LSK5hkEwZfUb2qHf+VRq8yvPM/rWpY1k5lrGgUCAKZpThQ4O2sMiMrwm9T3so8o2+FXph/sCf9J1JJ61sqAoHw2TRMZvbYjV+WvOOq9AIjUMne9Xt/ADxouDZIjCuK4tJNq2q6p6mVVKflD6ygMAQRH7sWHdp7fw3PU7GNN02BeF3sR0d31NB9Ag+yjfJPUIock7aAUiFSHbxJIXN8sbdv+npelRHRxLVNEyE6n0x8Oh/9bpikrA6CTXPAoIycdNbxvYhfrAzQMEAXOFRAAcM6XhmEswET27TsnVmilYsATh+bbFBSKoHxwUzLE2VuLp4kyGeKUXPmwJ+66lN2/poOfF9u2i+u5qOsfvSkzbkWCW0YUKfZosS0jR6tO0caWEUWKPVrsP20uaX77gHk9AAAAAElFTkSuQmCC" width="50" height="50"></span></a><span style="color:inherit;"> &nbsp;</span></td>
//           </tr>
//         </tbody>
//     </table>
//   </figure>`

export const SIGNATURE_DUMMY = 
  `<figure class="table" style="width:100%;font-family:Arial, Helvetica, sans-serif;margin:0;">
    <table style="font-family:Arial, Helvetica, sans-serif;">
        <tbody>
            <tr style="border:0">
                <td style="width:80px;">
                    <figure style="height:auto;width:70px;" class="image image_resized">
                        <img style="aspect-ratio:70/auto;" src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/user-placeholder.png"
                            alt="Signature Default" width="70" height="auto" />
                    </figure>
                </td>
                <td>
                  <span style="color:rgb(5, 40, 101);font-family:Arial, Helvetica, sans-serif;font-size:18px;"><strong>Enter Full Name</strong></span>
                    <br>
                    <span style="color:rgb(5, 40, 101);font-family:Arial, Helvetica, sans-serif;font-size:16px;">Enter Designation</span>
                </td>
            </tr>
            <tr style="border:0">
                <td colspan="2" align="middle" style="font-family:Arial, Helvetica, sans-serif;font-size:16px;">
                    <span style="vertical-align: middle;">
                        <img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/telephone.png" alt="Direct Phone"
                            width="15" height="15" />
                    </span>
                    <span style="color: #09396a;font-family:Arial, Helvetica, sans-serif;font-size:16px;vertical-align: middle;"> Direct
                        Phone:&nbsp;407.476.2064</span>
                    <br />

                    <span style="vertical-align: middle;">
                        <img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/phone-call.png" alt="Office Phone"
                            width="13" height="13" />
                    </span>
                    <span style="color: #09396a;font-family:Arial, Helvetica, sans-serif;font-size:16px;vertical-align: middle;"> Office
                        Phone:&nbsp;407.478.1111</span>
                    <br />

                    <span style="vertical-align: middle;">
                        <img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/loaction.png" alt="Address" width="15"
                            height="15" /></span>
                    <span style="color: #09396a;font-family:Arial, Helvetica, sans-serif;font-size:16px;vertical-align: middle;">301
                        E Pine St,&nbsp;Suite 450, Orlando, FL
                        32801</span>
                    <br />

                    <span style="vertical-align: middle;">
                        <img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/globe.png" alt="www.colombohurdlaw.com"
                            width="14" height="14" /></span>
                        <span style="color: #09396a;font-family:Arial, Helvetica, sans-serif;font-size:16px;vertical-align: middle;">www.colombohurdlaw.com</span>
                    <br /><br />

                    <span style="vertical-align: middle;padding-right: 10px;">
                        <img src="https://immigrationdev.blob.core.windows.net/envs/logo.png?sp=r&st=2024-01-23T05:39:51Z&se=2047-01-24T13:39:51Z&spr=https&sv=2022-11-02&sr=b&sig=Ktgzjc5DeBhqwUpV1pkSfe1xa64buAHVSrmGg7YDdKA%3D" alt="Colombo & Hurd, PL"
                            width="187" height="34" />
                    </span>
                    <span>&nbsp;&nbsp;</span>
                    <span>&nbsp;</span><a href="https://www.linkedin.com/company/colombo-&-hurd/" aria-label="LinkedIn" target="_blank" style="color:inherit!important;text-decoration:none;display:inline-block;vertical-align:middle"><span style="vertical-align:middle"><img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/linkedin.png" width="22" height="22" alt="LinkedIn"></span></a><span>&nbsp;</span><a href="https://www.instagram.com/colomboandhurd/" aria-label="Instagram" target="_blank" style="color:inherit!important;text-decoration:none;display:inline-block;vertical-align:middle"><span style="vertical-align:middle"><img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/instagram.png" width="22" height="22" alt="Instagram"></span></a><span>&nbsp;</span><a href="https://www.youtube.com/channel/UCWWZGKswGzpEvZUTLrhlAJw" aria-label="Youtube" target="_blank" style="color:inherit!important;text-decoration:none;display:inline-block;vertical-align:middle"><span style="vertical-align:middle"><img src="https://blobcontainerimmigration.blob.core.windows.net/signature-logo/youtube.png" width="24" height="24" alt="Youtube"></span></a>
                </td>
            </tr>
            <tr> 
              <td colspan="2" valign="top" style="width:393.75pt;font-size:10.66px;font-family:Aptos, sans-serif, serif;">              
                <hr />
                <p style="max-width:393.75pt;font-size:10.66px;font-family:Aptos, sans-serif, serif;">
                  <span style="max-width:393.75pt;color:rgb(132, 132, 132);font-size:10.66px;font-family:Aptos, sans-serif, serif;">The information in this email, including attachments, is confidential and protected by the attorney-client privilege. It is intended only for the use of the addressee(s). If you are not the intended recipient, you are hereby notified that any review, copying, printing, distribution, forwarding or the taking of any action based on the contents of this communication is prohibited.&nbsp; If you have received this email in error, please immediately notify the sender by reply email and delete the original email.
                  </span>
                </p>
              </td>
            </tr>
        </tbody>
    </table>
</figure>`

export const STEM_OPTIONS = [
  { label: "Select", value: "" },
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];


export const SIGNATURE_MESSAGE = "Images with a maximum of 200px height and 200px width are allowed, Individual file size limit is 1 MB."